(function() {
  'use strict';

  var WORKER = 'https://unreal-upload.unreal-rock.workers.dev';
  var member = window.__URS_MEMBER || {};

  /* ── HMAC auth (ONDA 0): token Bearer + x-urs-customer-id fallback ── */
  var URS_TOKEN = null;
  var URS_TOKEN_EXP = 0; // epoch seconds; token is refreshed before the server TTL runs out
  async function ursGetToken(force) {
    var now = Math.floor(Date.now() / 1000);
    if (!force && URS_TOKEN && URS_TOKEN_EXP > now + 60) return URS_TOKEN;
    if (!member || !member.id) return null;
    try {
      var r = await fetch(WORKER + '/api/auth', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ customer_id: String(member.id), tier: member.tier || 'listener' })
      });
      if (!r.ok) { URS_TOKEN = null; URS_TOKEN_EXP = 0; return null; }
      var d = await r.json();
      URS_TOKEN = d.token || null;
      URS_TOKEN_EXP = now + (Number(d.expires_in) || 3600);
      return URS_TOKEN;
    } catch (e) { return null; }
  }
  function ursAuthHeaders(extra) {
    var h = extra || {};
    if (member && member.id) h['x-urs-customer-id'] = String(member.id);
    if (URS_TOKEN) h['Authorization'] = 'Bearer ' + URS_TOKEN;
    if (member && member.tier) h['x-urs-tier'] = member.tier;
    return h;
  }
  /* Authed fetch: attaches auth, and on 401 mints a fresh token and retries ONCE.
     Logged-out visitors degrade to a plain fetch (no headers) exactly as before. */
  async function ursAuthedFetch(url, opts) {
    opts = opts || {};
    await ursGetToken();
    var o1 = Object.assign({}, opts);
    o1.headers = ursAuthHeaders(Object.assign({}, opts.headers || {}));
    var r = await fetch(url, o1);
    if (r.status !== 401) return r;
    await ursGetToken(true);
    var o2 = Object.assign({}, opts);
    o2.headers = ursAuthHeaders(Object.assign({}, opts.headers || {}));
    return fetch(url, o2);
  }

  /* ── DOM refs ── */
  var drawer = document.getElementById('urs-drawer');
  var backdrop = document.getElementById('urs-drawer-backdrop');
  var closeBtn = document.getElementById('urs-drawer-close');
  var drawerCover = document.getElementById('urs-drawer-cover');
  var drawerTitle = document.getElementById('urs-drawer-title');
  var drawerArtist = document.getElementById('urs-drawer-artist');
  var drawerPlay = document.getElementById('urs-drawer-play');
  var drawerDownload = document.getElementById('urs-drawer-download');
  var tracklistSection = document.getElementById('urs-drawer-tracklist-section');
  var tracklistEl = document.getElementById('urs-drawer-tracklist');
  var playerEl = document.getElementById('urs-player');
  var audio = document.getElementById('urs-audio');
  var toggleBtn = document.getElementById('urs-player-toggle');
  var prevBtn = document.getElementById('urs-player-prev');
  var nextBtn = document.getElementById('urs-player-next');
  var seekBar = document.getElementById('urs-player-seek');
  var currentTimeEl = document.getElementById('urs-player-current');
  var durationEl = document.getElementById('urs-player-duration');
  var trackNameEl = document.getElementById('urs-player-track');
  var iconPlay = toggleBtn ? toggleBtn.querySelector('.urs-player__icon-play') : null;
  var iconPause = toggleBtn ? toggleBtn.querySelector('.urs-player__icon-pause') : null;
  var npBar = document.getElementById('urs-nowplaying');
  var npCover = document.getElementById('urs-np-cover');
  var npTitle = document.getElementById('urs-np-title');
  var npArtist = document.getElementById('urs-np-artist');
  var npToggle = document.getElementById('urs-np-toggle');
  var npPrev = document.getElementById('urs-np-prev');
  var npNext = document.getElementById('urs-np-next');
  var npProgressFill = document.getElementById('urs-np-progress-fill');
  var npProgress = document.getElementById('urs-np-progress');
  var npCurrent = document.getElementById('urs-np-current');
  var npDuration = document.getElementById('urs-np-duration');
  var npIconPlay = npToggle ? npToggle.querySelector('.urs-np-icon-play') : null;
  var npIconPause = npToggle ? npToggle.querySelector('.urs-np-icon-pause') : null;
  var heroBlur = document.getElementById('urs-drawer-blur');
  var seekFill = document.getElementById('urs-player-fill');
  var volumeSlider = document.getElementById('urs-player-volume');
  var muteBtn = document.getElementById('urs-player-mute');
  var volIconOn = muteBtn ? muteBtn.querySelector('.urs-vol-icon-on') : null;
  var volIconOff = muteBtn ? muteBtn.querySelector('.urs-vol-icon-off') : null;
  var shuffleBtn = document.getElementById('urs-player-shuffle');
  var repeatBtn = document.getElementById('urs-player-repeat');
  var lyricsBtn = document.getElementById('urs-player-lyrics');
  var supportedByEl = document.getElementById('urs-drawer-supported');
  var currentSupporters = [];
  function openSupportersModal(fans) {
    var old = document.getElementById('urs-supporters-modal'); if (old) old.remove();
    var rows = (fans || []).map(function (fn) {
      var av = fn.avatar
        ? '<img class="urs-supmodal__av" src="' + WORKER + '/cdn/' + escHtml(fn.avatar) + '" alt="">'
        : '<span class="urs-supmodal__av urs-supmodal__av--ini">' + escHtml((fn.name || '?').charAt(0).toUpperCase()) + '</span>';
      var href = fn.id ? '/pages/member-profile?id=' + encodeURIComponent(fn.id) : '#';
      return '<a class="urs-supmodal__row" href="' + href + '">' + av + '<span class="urs-supmodal__name">' + escHtml(fn.name || 'Member') + '</span>' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg></a>';
    }).join('');
    var m = document.createElement('div'); m.id = 'urs-supporters-modal'; m.className = 'urs-supmodal';
    m.innerHTML = '<div class="urs-supmodal__backdrop" data-sup-close></div>' +
      '<div class="urs-supmodal__panel" role="dialog" aria-modal="true" aria-label="Supporters">' +
      '<div class="urs-supmodal__head"><h3>Supported by <span class="urs-supmodal__count">' + (fans ? fans.length : 0) + '</span></h3>' +
      '<button class="urs-supmodal__close" type="button" data-sup-close aria-label="Close"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg></button></div>' +
      '<div class="urs-supmodal__list">' + rows + '</div></div>';
    document.body.appendChild(m);
    function close() { m.remove(); document.removeEventListener('keydown', onKey); }
    function onKey(e) { if (e.key === 'Escape') close(); }
    m.addEventListener('click', function (e) { if (e.target.closest('[data-sup-close]')) { e.preventDefault(); close(); } });
    document.addEventListener('keydown', onKey);
    requestAnimationFrame(function () { m.classList.add('is-open'); });
  }
  var lyricsEl = document.getElementById('urs-drawer-lyrics');
  var lyricsText = document.getElementById('urs-lyrics-text');
  var searchInput = document.getElementById('urs-search');
  var searchClear = document.getElementById('urs-search-clear');
  var searchEmpty = document.getElementById('urs-search-empty');
  var catalogGrid = document.getElementById('urs-catalog-grid');
  var artistFilter = document.getElementById('urs-filter-artist');
  var sortFilter = document.getElementById('urs-filter-sort');

  /* ── State ── */
  var allAlbums = [];
  var catalogView = 'browse';
  var resultsSource = '';
  var currentTracks = [];
  var currentTrackIndex = 0;
  var currentAlbumMeta = { title: '', artist: '', image: '' };
  var resolvedUrls = {};
  var isPlaying = false;
  var userProfile = null;
  var likeCountsCache = {};
  var isShuffle = false;
  var repeatMode = 0;
  var savedVolume = 0.8;
  var lyricsEnabled = false;

  /* ── Helpers ── */
  function formatTime(s) {
    if (!s || isNaN(s)) return '0:00';
    var m = Math.floor(s / 60);
    var sec = Math.floor(s % 60);
    return m + ':' + (sec < 10 ? '0' : '') + sec;
  }

  function escHtml(s) {
    if (!s) return '';
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function slugify(s) {
    return (s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-+$/, '').replace(/^-+/, '');
  }

  function likeKey(artist, album) {
    return slugify(artist) + '_' + slugify(album);
  }

  /* ── Tier helpers ── */
  function canStream(track) {
    if (!track.premium) return true;
    return member.tier === 'insider' || member.tier === 'legend';
  }

  function canDownload() {
    return member.tier === 'legend';
  }

  /* ── MEMBER-O14: tier-based catalog gating ── */
  var URS_TIER_RANK = { listener: 1, insider: 2, legend: 3 };
  var URS_LOCK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>';
  function albumTiers(al) { return (al && al.allowed_tiers && al.allowed_tiers.length) ? al.allowed_tiers : ['listener', 'insider', 'legend']; }
  function albumLocked(al) { return albumTiers(al).indexOf(member.tier) === -1; }
  function albumMinTier(al) { var ts = albumTiers(al), best = null; for (var i = 0; i < ts.length; i++) { if (best === null || URS_TIER_RANK[ts[i]] < URS_TIER_RANK[best]) best = ts[i]; } return best || 'insider'; }
  function tierCap(t) { return t ? (t.charAt(0).toUpperCase() + t.slice(1)) : ''; }
  function openUpgrade(needTier) { try { window.location.href = '/pages/club#tiers'; } catch (e) {} }
  function tierBannerHtml() {
    var t = member.tier;
    var have = (typeof allAlbums !== 'undefined' && allAlbums) ? allAlbums : [];
    var total = have.length, unlocked = 0;
    for (var i = 0; i < have.length; i++) { if (!albumLocked(have[i])) unlocked++; }
    var locked = total - unlocked;
    if (t === 'legend') return '<div class="urs-tierbar urs-tierbar--insider"><span class="urs-tierbar__badge">INSIDER</span><span class="urs-tierbar__txt">Full access unlocked \u2014 every album.</span></div>';
    if (t === 'insider') return '<div class="urs-tierbar urs-tierbar--insider"><span class="urs-tierbar__badge">INSIDER</span><span class="urs-tierbar__txt">Full catalog unlocked.</span></div>';
    if (t === 'listener') return '<div class="urs-tierbar urs-tierbar--listener"><span class="urs-tierbar__badge">LISTENER</span><span class="urs-tierbar__txt"><strong>' + unlocked + '</strong> albums unlocked. Upgrade to <strong>Insider</strong> to unlock the full catalog (<strong>' + locked + '</strong> more).</span><a class="urs-tierbar__cta" href="/pages/club#tiers">Upgrade to Insider</a></div>';
    return '<div class="urs-tierbar urs-tierbar--none"><span class="urs-tierbar__txt">Join Unreal Rock + to unlock the catalog.</span><a class="urs-tierbar__cta" href="/pages/club#tiers">See plans</a></div>';
  }
  function renderTierBanner() {
    var sec = document.getElementById('urs-section-catalog');
    if (!sec) return;
    var old = document.getElementById('urs-tier-banner'); if (old && old.parentNode) old.parentNode.removeChild(old);
    var div = document.createElement('div'); div.id = 'urs-tier-banner'; div.innerHTML = tierBannerHtml();
    var hdr = sec.querySelector('.urs-catalog__header');
    if (hdr && hdr.nextSibling) sec.insertBefore(div, hdr.nextSibling); else sec.insertBefore(div, sec.firstChild);
  }

  /* ── Play Icons Sync ── */
  function syncPlayIcons(playing) {
    isPlaying = playing;
    try { if ('mediaSession' in navigator) navigator.mediaSession.playbackState = playing ? 'playing' : 'paused'; } catch (e) {}
    if (iconPlay) iconPlay.style.display = playing ? 'none' : '';
    if (iconPause) iconPause.style.display = playing ? '' : 'none';
    if (toggleBtn) toggleBtn.setAttribute('aria-label', playing ? 'Pause' : 'Play');
    if (npIconPlay) npIconPlay.style.display = playing ? 'none' : '';
    if (npIconPause) npIconPause.style.display = playing ? '' : 'none';
    /* MEMBER-O5f: big album-page play button reflects play/pause */
    var _apIcon = document.querySelector('#urs-drawer-play .urs-albumpage__play-icon path') || document.querySelector('#urs-drawer-play svg path');
    if (_apIcon) _apIcon.setAttribute('d', playing ? 'M6 5h4v14H6zM14 5h4v14h-4z' : 'M8 5v14l11-7z');
    var _apBtn = document.getElementById('urs-drawer-play'); if (_apBtn) _apBtn.setAttribute('aria-label', playing ? 'Pause album' : 'Play album');
  }

  function highlightTrack(index) {
    if (!tracklistEl) return;
    var items = tracklistEl.querySelectorAll('.urs-drawer__track');
    for (var i = 0; i < items.length; i++) {
      items[i].classList.toggle('urs-track--active', i === index);
    }
  }

  function updateNowPlaying() {
    if (!npBar) return;
    if (!currentTracks.length) { npBar.style.display = 'none'; return; }
    var track = currentTracks[currentTrackIndex];
    npBar.style.display = '';
    if (npCover) { npCover.src = currentAlbumMeta.image || ''; npCover.alt = currentAlbumMeta.title; }
    var titleText = track ? track.title : '';
    if (track && track.premium && !canStream(track)) titleText += ' (preview)';
    if (npTitle) npTitle.textContent = titleText;
    if (npArtist) npArtist.textContent = currentAlbumMeta.artist || '';
    var plArtist = document.getElementById('urs-player-artist');
    if (plArtist) plArtist.textContent = currentAlbumMeta.artist || '';
    ursMediaSession(track);
  }

  /* ── Media Session: nome/artista/capa no CARRO, tela de bloqueio e bluetooth,
     + botoes proxima/anterior do volante. Sem isso o carro mostra so o titulo da
     pagina ("Member area") e os controles nao passam de faixa. ── */
  function ursMediaSession(track) {
    if (!('mediaSession' in navigator)) return;
    try {
      var cover = (currentAlbumMeta && currentAlbumMeta.image) || '';
      var art = [];
      if (cover) { ['256x256','512x512','1400x1400'].forEach(function(sz){ art.push({ src: cover, sizes: sz, type: 'image/png' }); }); }
      navigator.mediaSession.metadata = new MediaMetadata({
        title: (track && track.title) || (currentAlbumMeta && currentAlbumMeta.title) || 'Unreal Rock Songs',
        artist: (currentAlbumMeta && currentAlbumMeta.artist) || 'Unreal Rock Songs',
        album: (currentAlbumMeta && currentAlbumMeta.title) || '',
        artwork: art
      });
    } catch (e) {}
  }
  var _msActionsSet = false;
  function ursMediaSessionActions() {
    if (_msActionsSet || !('mediaSession' in navigator)) return;
    _msActionsSet = true;
    var acts = [
      ['play', function(){ if(audio){ audio.play().then(function(){ syncPlayIcons(true); }).catch(function(){}); } }],
      ['pause', function(){ if(audio){ audio.pause(); syncPlayIcons(false); } }],
      ['previoustrack', function(){ playTrack(currentTrackIndex - 1); }],
      ['nexttrack', function(){ playTrack(currentTrackIndex + 1); }],
      ['seekbackward', function(d){ if(!audio)return; var k=(d&&d.seekOffset)||10; audio.currentTime=Math.max((audio.currentTime||0)-k,0); }],
      ['seekforward', function(d){ if(!audio)return; var k=(d&&d.seekOffset)||10; audio.currentTime=Math.min((audio.currentTime||0)+k, audio.duration||0); }],
      ['seekto', function(d){ if(audio && d && d.seekTime!=null) audio.currentTime=d.seekTime; }]
    ];
    for (var i=0;i<acts.length;i++){ try { navigator.mediaSession.setActionHandler(acts[i][0], acts[i][1]); } catch(e){} }
  }
  function ursMediaPos() {
    if (!('mediaSession' in navigator) || !('setPositionState' in navigator.mediaSession) || !audio) return;
    try { if (audio.duration && isFinite(audio.duration)) navigator.mediaSession.setPositionState({ duration: audio.duration, playbackRate: audio.playbackRate || 1, position: audio.currentTime || 0 }); } catch (e) {}
  }

  /* ── Audio URL resolution ── */
  function resolvePreviewUrl(previewLink) {
    return fetch(previewLink, { credentials: 'include' })
      .then(function(r) {
        var ct = r.headers.get('content-type') || '';
        if (ct.indexOf('audio') !== -1 || ct.indexOf('octet') !== -1) return r.url || previewLink;
        return r.text().then(function(t) {
          var trimmed = t.trim();
          if (trimmed.indexOf('http') === 0) return trimmed;
          try { var j = JSON.parse(trimmed); return j.href || j.url || j.src || previewLink; }
          catch(e) { return previewLink; }
        });
      })
      .catch(function() { return previewLink; });
  }

  /* URLs assinadas vencem em 12h. Se o membro deixa a aba aberta alem disso, a
     faixa daria 403 "Forbidden" ao tocar e ficaria muda. Aqui detectamos o
     vencimento e renovamos o catalogo em silencio, sem o membro perceber. */
  function ursSignedExp(u) {
    u = u || "";
    var i = u.indexOf("t=");
    if (i === -1) return 0;
    var d = "", r = u.slice(i + 2);
    for (var k = 0; k < r.length; k++) { var ch = r.charCodeAt(k); if (ch >= 48 && ch <= 57) d += r[k]; else break; }
    return d ? Number(d) : 0;
  }
  function ursSignedExpired(u) {
    var e = ursSignedExp(u);
    return e > 0 && e <= (Math.floor(Date.now() / 1000) + 120);
  }
  function ursFreshFor(oldUrl) {
    var p = (oldUrl || "").split("?")[0];
    for (var i = 0; i < allAlbums.length; i++) {
      var tr = allAlbums[i].tracks || [];
      for (var j = 0; j < tr.length; j++) { if (tr[j].url && tr[j].url.split("?")[0] === p) return tr[j].url; }
    }
    return null;
  }
  var _urlRenew = null;
  function ursRenewSignedUrls() {
    if (_urlRenew) return _urlRenew;
    _urlRenew = ursAuthedFetch(WORKER + "/api/albums")
      .then(function (r) { return r.json(); })
      .then(function (data) {
        allAlbums = data.albums || [];
        var fresh = {};
        for (var i = 0; i < allAlbums.length; i++) { var tr = allAlbums[i].tracks || []; for (var j = 0; j < tr.length; j++) { if (tr[j].url) fresh[tr[j].url.split("?")[0]] = tr[j].url; } }
        for (var k = 0; k < currentTracks.length; k++) { var p = (currentTracks[k].stream || "").split("?")[0]; if (p && fresh[p]) currentTracks[k].stream = fresh[p]; }
        resolvedUrls = {};
        _urlRenew = null;
        return fresh;
      })
      .catch(function () { _urlRenew = null; return {}; });
    return _urlRenew;
  }

    var _healBusy = false, _healBlob = null;
    // "Modo blob": quando a midia direta e bloqueada (adblock), passamos a buscar
    // por fetch e tocar como blob do proprio dominio (imune a bloqueio de midia).
    // Fica lembrado em localStorage pra nao repetir a deteccao a cada faixa/sessao.
    var _blobMode = false;
    try { _blobMode = localStorage.getItem('urs_blobmode') === '1'; } catch (e) {}
    function _ursSetBlobMode(on) {
      _blobMode = on;
      try { if (on) localStorage.setItem('urs_blobmode', '1'); else localStorage.removeItem('urs_blobmode'); } catch (e) {}
    }
    function _ursHealReload() {
      try { if (!sessionStorage.getItem('urs_healed')) { sessionStorage.setItem('urs_healed', '1'); location.reload(); } } catch (e) {}
    }
    // Toca uma faixa buscando por fetch (passa pelo adblock, igual o catalogo) e
    // reproduzindo como blob same-origin. Marca modo blob no sucesso.
    function ursPlayBlob(cdnUrl, wasPos, onFail) {
      fetch(cdnUrl).then(function (r) { return (r && r.ok) ? r.blob() : null; }).then(function (b) {
        if (!b) { if (onFail) onFail(); return; }
        if (_healBlob) { try { URL.revokeObjectURL(_healBlob); } catch (e) {} }
        _healBlob = URL.createObjectURL(b);
        audio.src = _healBlob;
        try { if (wasPos > 0) audio.currentTime = wasPos; } catch (e) {}
        audio.play().then(function(){ syncPlayIcons(true); }).catch(function(){});
        _ursSetBlobMode(true);
      }).catch(function () { if (onFail) onFail(); });
    }
    // Cura silenciosa (no 'error' E quando o audio TRAVA — adblock costuma travar a
    // midia sem disparar error). Expirou -> renova. Bloqueio/travou -> blob. Se nem
    // o fetch passar -> reload unico.
    function ursHealAudio() {
      var src = (audio.src || '').split('#')[0];
      if (_healBusy || src.indexOf('blob:') !== -1) return;
      if (src.indexOf('/cdn/') === -1) return;
      _healBusy = true;
      var wasPos = audio.currentTime || 0;
      if (typeof ursSignedExpired === 'function' && ursSignedExpired(src)) {
        ursRenewSignedUrls().then(function () {
          var fresh = ursFreshFor(src) || src;
          audio.src = fresh;
          try { if (wasPos > 0) audio.currentTime = wasPos; } catch (e) {}
          audio.play().then(function(){ syncPlayIcons(true); }).catch(function(){});
          _healBusy = false;
        }).catch(function(){ _healBusy = false; });
      } else {
        ursPlayBlob(src, wasPos, _ursHealReload);
        setTimeout(function(){ _healBusy = false; }, 800);
      }
    }

  function resolveTrackUrl(track) {
    var cacheKey = track.url || track.stream || track.title;
    if (track.stream && ursSignedExpired(track.stream)) {
      return ursRenewSignedUrls().then(function () {
        var fresh = ursFreshFor(track.stream);
        if (fresh) track.stream = fresh;
        resolvedUrls[track.url || track.stream || track.title] = track.stream;
        return track.stream;
      });
    }
    if (resolvedUrls[cacheKey]) return Promise.resolve(resolvedUrls[cacheKey]);
    if (track.stream) { resolvedUrls[cacheKey] = track.stream; return Promise.resolve(track.stream); }
    if (!track.url) return Promise.resolve(null);
    return resolvePreviewUrl(track.url).then(function(src) { resolvedUrls[cacheKey] = src; return src; });
  }

  function preResolveAll(tracks) {
    var promises = [];
    for (var i = 0; i < tracks.length; i++) promises.push(resolveTrackUrl(tracks[i]));
    return Promise.all(promises);
  }

  /* ── Track loading & playback ── */
  function findPlayableTrack(from, dir) {
    for (var i = 0; i < currentTracks.length; i++) {
      var idx = (from + dir * (i + 1)) % currentTracks.length;
      if (idx < 0) idx += currentTracks.length;
      if (!currentTracks[idx].premium || canStream(currentTracks[idx])) return idx;
    }
    return -1;
  }

  function loadTrack(index, autoplay) {
    if (!currentTracks.length || !audio) return;
    if (index < 0) index = currentTracks.length - 1;
    if (index >= currentTracks.length) index = 0;
    var track = currentTracks[index];

    if (track.premium && !canStream(track)) {
      var dir = index >= currentTrackIndex ? 1 : -1;
      var playable = findPlayableTrack(index, dir);
      if (playable === -1) { ursToast('🔒 This album is exclusive to a higher plan.'); return; }
      index = playable;
      track = currentTracks[index];
    }
    currentTrackIndex = index;

    if (trackNameEl) trackNameEl.textContent = track.title;
    highlightTrack(index);
    if (seekBar) seekBar.value = 0;
    if (seekFill) seekFill.style.width = '0%';
    if (currentTimeEl) currentTimeEl.textContent = '0:00';
    if (durationEl) durationEl.textContent = track.time || '0:00';
    if (playerEl) playerEl.style.display = '';
    updateNowPlaying();
    loadLyrics(currentAlbumMeta.artist, currentAlbumMeta.title, index);

    var trackEl = tracklistEl ? tracklistEl.querySelector('[data-index="' + index + '"]') : null;
    if (trackEl) trackEl.classList.add('urs-track--loading');

    resolveTrackUrl(track).then(function(src) {
      if (trackEl) trackEl.classList.remove('urs-track--loading');
      if (!src) { ursToast('🔒 Upgrade your plan to listen to this.'); syncPlayIcons(false); return; }
      if (typeof _blobMode !== 'undefined' && _blobMode && autoplay && src.indexOf('/cdn/') !== -1) {
        // ja sabemos que a midia direta e bloqueada -> vai direto de blob (sem os 4s)
        ursPlayBlob(src, 0, function(){
          _ursSetBlobMode(false); // fetch tambem falhou -> desiste do blob, tenta normal
          audio.src = src;
          audio.play().then(function(){ syncPlayIcons(true); }).catch(function(){ syncPlayIcons(false); });
        });
      } else {
        audio.src = src;
        if (autoplay) {
          audio.play().then(function() { syncPlayIcons(true); }).catch(function() { syncPlayIcons(false); });
          // watchdog: adblock costuma TRAVAR a midia sem disparar 'error'. Se em 4s
          // nao andou nada, dispara a cura (blob) sozinho.
          (function(watchSrc){ setTimeout(function(){
            if (audio.src === watchSrc && !audio.paused && audio.currentTime < 0.3 && audio.readyState < 3) ursHealAudio();
          }, 4000); })(audio.src);
        } else {
          audio.load();
          syncPlayIcons(false);
        }
      }
    });
  }

  function playTrack(index) { loadTrack(index, true); }

  /* ── Player controls ── */
  function togglePlay() {
    if (!audio) return;
    if (audio.paused) {
      if (!audio.src || audio.src === location.href) {
        if (currentTracks.length) playTrack(0);
        return;
      }
      audio.play().then(function() { syncPlayIcons(true); }).catch(function() {});
    } else {
      audio.pause();
      syncPlayIcons(false);
    }
  }

  if (toggleBtn) toggleBtn.addEventListener('click', togglePlay);
  if (npToggle) npToggle.addEventListener('click', togglePlay);
  if (prevBtn) prevBtn.addEventListener('click', function() { playTrack(currentTrackIndex - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function() { playTrack(currentTrackIndex + 1); });
  if (npPrev) npPrev.addEventListener('click', function() { playTrack(currentTrackIndex - 1); });
  if (npNext) npNext.addEventListener('click', function() { playTrack(currentTrackIndex + 1); });

  if (audio) {
    audio.addEventListener('timeupdate', function() {
      if (!audio.duration) return;
      var pct = (audio.currentTime / audio.duration) * 100;
      if (seekBar) seekBar.value = pct * 10;
      if (seekFill) seekFill.style.width = pct + '%';
      if (currentTimeEl) currentTimeEl.textContent = formatTime(audio.currentTime);
      if (npProgressFill) npProgressFill.style.width = pct + '%';
      if (npCurrent) npCurrent.textContent = formatTime(audio.currentTime);
      // fallback pro bug do iOS: as vezes 'ended' nao dispara com a tela travada.
      if (isFinite(audio.duration) && audio.duration > 0 && audio.currentTime >= audio.duration - 0.35) ursAdvanceNext();
    });
    audio.addEventListener('loadedmetadata', function() {
      if (durationEl) durationEl.textContent = formatTime(audio.duration);
      if (npDuration) npDuration.textContent = formatTime(audio.duration);
      ursMediaPos();
    });
    var _lastAdvance = 0;
    function ursAdvanceNext() {
      if (!audio) return;
      var now = Date.now();
      if (now - _lastAdvance < 1500) return; // debounce: 'ended' e o fallback do timeupdate nao avancam 2x
      _lastAdvance = now;
      if (repeatMode === 2) { playTrack(currentTrackIndex); return; }
      if (currentTrackIndex < currentTracks.length - 1) {
        var next = isShuffle ? Math.floor(Math.random() * currentTracks.length) : currentTrackIndex + 1;
        playTrack(next);
      } else if (repeatMode === 1) {
        playTrack(0);
      } else {
        syncPlayIcons(false);
      }
    }
    audio.addEventListener('ended', ursAdvanceNext);
    audio.addEventListener('play', function() { syncPlayIcons(true); ursMediaPos(); });
    audio.addEventListener('pause', function() { syncPlayIcons(false); });
    ursMediaSessionActions();
    // Auto-heal: se uma url /cdn falhar, renova e retoma. Se falhar de novo mesmo
    // apos renovar (ex: aba com codigo velho que so agora recarregou, estado preso),
    // recarrega a pagina UMA vez sozinho — pega codigo e urls frescas sem ninguem
    // fazer nada. Guardado por sessionStorage pra nunca entrar em loop.
    // Auto-heal em camadas, tudo silencioso, sem o membro fazer nada:
    //  1) URL /cdn falhou  -> renova a assinatura e retoma do mesmo ponto.
    //  2) Ainda falhou     -> busca via fetch (CORS) e toca como blob same-origin.
    //     Contorna regra de adblock que bloqueia requisicao de MIDIA mas deixa
    //     fetch passar. So ativa no erro; nao afeta quem esta tocando normal.
    //  3) Ainda falhou     -> recarrega a pagina UMA vez (guard sessionStorage).
    audio.addEventListener('error', function() { ursHealAudio(); });
  }
  if (seekBar && audio) {
    seekBar.addEventListener('input', function() {
      if (audio.duration) audio.currentTime = (seekBar.value / 1000) * audio.duration;
    });
  }
  /* ── MEMBER-O5: draggable seek on the bottom bar ── */
  if (npProgress && audio) {
    var npDragging = false;
    var npSeekTo = function(clientX) {
      var rect = npProgress.getBoundingClientRect();
      var pct = (clientX - rect.left) / rect.width;
      pct = Math.max(0, Math.min(1, pct));
      if (npProgressFill) npProgressFill.style.width = (pct * 100) + '%';
      if (audio.duration) audio.currentTime = pct * audio.duration;
    };
    npProgress.addEventListener('mousedown', function(e) { npDragging = true; npProgress.classList.add('is-dragging'); npSeekTo(e.clientX); e.preventDefault(); });
    document.addEventListener('mousemove', function(e) { if (npDragging) npSeekTo(e.clientX); });
    document.addEventListener('mouseup', function() { if (npDragging) { npDragging = false; npProgress.classList.remove('is-dragging'); } });
    npProgress.addEventListener('touchstart', function(e) { npDragging = true; npProgress.classList.add('is-dragging'); if (e.touches[0]) npSeekTo(e.touches[0].clientX); }, { passive: true });
    npProgress.addEventListener('touchmove', function(e) { if (npDragging && e.touches[0]) npSeekTo(e.touches[0].clientX); }, { passive: true });
    npProgress.addEventListener('touchend', function() { if (npDragging) { npDragging = false; npProgress.classList.remove('is-dragging'); } });
  }

  /* ── MEMBER-O5: bottom-bar volume + mute + fullscreen-expand ── */
  var npVolume = document.getElementById('urs-np-volume');
  var npMute = document.getElementById('urs-np-mute');
  var npFullscreenBtn = document.getElementById('urs-np-fullscreen');
  var npVolOn = npMute ? npMute.querySelector('.urs-np-vol-on') : null;
  var npVolOff = npMute ? npMute.querySelector('.urs-np-vol-off') : null;
  function npSyncVolIcon() {
    var muted = !audio || audio.volume === 0;
    if (npVolOn) npVolOn.style.display = muted ? 'none' : '';
    if (npVolOff) npVolOff.style.display = muted ? '' : 'none';
  }
  if (npVolume && audio) {
    npVolume.value = Math.round((audio.volume || 0.8) * 100);
    npVolume.addEventListener('input', function() {
      audio.volume = npVolume.value / 100;
      savedVolume = audio.volume;
      if (volumeSlider) volumeSlider.value = npVolume.value;  // keep hidden #urs-player-volume in sync
      npSyncVolIcon();
    });
  }
  if (npMute && audio) {
    npMute.addEventListener('click', function() {
      if (audio.volume > 0) { savedVolume = audio.volume; audio.volume = 0; }
      else { audio.volume = savedVolume || 0.8; }
      var v = Math.round(audio.volume * 100);
      if (npVolume) npVolume.value = v;
      if (volumeSlider) volumeSlider.value = v;
      npSyncVolIcon();
    });
  }
  if (npFullscreenBtn) {
    npFullscreenBtn.addEventListener('click', function() {
      if (typeof openFullscreen === 'function') openFullscreen();
      else if (window.__ursOpenFullscreen) window.__ursOpenFullscreen();
    });
  }
  npSyncVolIcon();

  /* ── Volume & Shuffle/Repeat ── */
  if (volumeSlider && audio) {
    audio.volume = 0.8;
    volumeSlider.addEventListener('input', function() {
      audio.volume = volumeSlider.value / 100;
      savedVolume = audio.volume;
      syncVolIcon();
    });
  }
  if (muteBtn && audio) {
    muteBtn.addEventListener('click', function() {
      if (audio.volume > 0) { savedVolume = audio.volume; audio.volume = 0; if (volumeSlider) volumeSlider.value = 0; }
      else { audio.volume = savedVolume || 0.8; if (volumeSlider) volumeSlider.value = Math.round(audio.volume * 100); }
      syncVolIcon();
    });
  }
  function syncVolIcon() {
    var muted = !audio || audio.volume === 0;
    if (volIconOn) volIconOn.style.display = muted ? 'none' : '';
    if (volIconOff) volIconOff.style.display = muted ? '' : 'none';
  }
  if (shuffleBtn) {
    shuffleBtn.addEventListener('click', function() {
      isShuffle = !isShuffle;
      shuffleBtn.setAttribute('aria-pressed', isShuffle);
    });
  }
  /* ── MEMBER-O5: album-page action bar wiring ── */
  var albumPlayBtn = document.getElementById('urs-drawer-play');
  if (albumPlayBtn) {
    albumPlayBtn.addEventListener('click', function(e) {
      e.preventDefault();
      if (!currentTracks.length) return;
      // If audio is loaded, toggle; otherwise start the album from track 0.
      if (audio && audio.src) { togglePlay(); return; }
      playTrack(0);
    });
  }
  var albumShuffleBtn = document.getElementById('urs-drawer-shuffle-action');
  if (albumShuffleBtn) {
    albumShuffleBtn.addEventListener('click', function(e) {
      e.preventDefault();
      if (shuffleBtn) { shuffleBtn.click(); }            // proxy the hidden #urs-player-shuffle
      else { isShuffle = !isShuffle; }
      albumShuffleBtn.setAttribute('aria-pressed', isShuffle ? 'true' : 'false');
    });
  }
  var albumDownloadBtn = document.getElementById('urs-drawer-download');
  if (albumDownloadBtn) {
    albumDownloadBtn.addEventListener('click', function(e) {
      e.preventDefault();
      if (!canDownload()) { window.location.href = '/pages/club#tiers'; return; }
      var dlTracks = (currentTracks || []).map(function(t) { return { name: t.title, url: t.stream || t.url, premium: t.premium }; });
      downloadAllSequential(dlTracks, 0);
    });
  }
  var albumLyricsBtn = document.getElementById('urs-drawer-lyrics-btn');
  if (albumLyricsBtn) {
    albumLyricsBtn.addEventListener('click', function(e) {
      e.preventDefault();
      if (typeof openFullscreen === 'function') openFullscreen();
      else if (window.__ursOpenFullscreen) window.__ursOpenFullscreen();
    });
  }

  if (lyricsBtn) {
    lyricsBtn.addEventListener('click', function() {
      lyricsEnabled = !lyricsEnabled;
      lyricsBtn.setAttribute('aria-pressed', lyricsEnabled);
      lyricsBtn.style.opacity = lyricsEnabled ? '1' : '';
      lyricsBtn.style.color = lyricsEnabled ? 'var(--member-accent)' : '';
      if (lyricsEnabled) {
        loadLyrics(currentAlbumMeta.artist, currentAlbumMeta.title, currentTrackIndex);
      } else {
        if (lyricsEl) lyricsEl.style.display = 'none';
      }
    });
  }

  /* ── Tracklist builder ── */
  function buildTracklist(tracks) {
    if (!tracklistEl || !tracklistSection) return;
    var emptyEl = document.getElementById('urs-drawer-tracklist-empty');
    tracklistEl.innerHTML = '';
    currentTracks = [];
    if (!tracks || !tracks.length) {
      tracklistSection.style.display = 'none';
      if (emptyEl) { emptyEl.style.display = ''; emptyEl.textContent = 'No tracks available.'; }
      if (playerEl) playerEl.style.display = 'none';
      return;
    }
    currentTracks = tracks;
    tracklistSection.style.display = '';
    if (emptyEl) emptyEl.style.display = 'none';
    if (playerEl) playerEl.style.display = '';
    for (var i = 0; i < tracks.length; i++) {
      var t = tracks[i];
      var li = document.createElement('li');
      li.className = 'urs-drawer__track';
      if (t.premium && !canStream(t)) li.className += ' urs-track--locked';
      li.setAttribute('data-index', i);
      li.setAttribute('role', 'button');
      li.setAttribute('tabindex', '0');
      var timeHtml = t.time ? '<span class="urs-drawer__track-time">' + t.time + '</span>' : '';
      var lockHtml = '';
      if (t.premium && !canStream(t)) {
        lockHtml = '<span class="urs-track__lock" title="Subscribe to listen"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg></span>';
      }
      li.innerHTML =
        '<span class="urs-drawer__track-eq" aria-hidden="true"><span></span><span></span><span></span></span>' +
        '<span class="urs-drawer__track-num">' + (i + 1) + '</span>' +
        '<span class="urs-drawer__track-title">' + escHtml(t.title) + '</span>' +
        '<button type="button" class="urs-track__add" data-add-track="' + i + '" title="Add to playlist" aria-label="Add to playlist"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></button>' +
        lockHtml + timeHtml;
      tracklistEl.appendChild(li);
    }
  }

  /* ── Lyrics ── */
  function loadLyrics(artist, album, trackIndex) {
    if (!lyricsEl || !lyricsText) return;
    lyricsEl.style.display = 'none';
    lyricsText.textContent = '';
    if (!lyricsEnabled) return;
    if (!artist || !album || !currentTracks[trackIndex]) return;
    var track = currentTracks[trackIndex];
    var num = (trackIndex + 1 < 10 ? '0' : '') + (trackIndex + 1);
    var lyricsPath = track.lyrics || ('lyrics/' + num + '-' + slugify(track.title) + '.txt');
    var url = WORKER + '/cdn/' + slugify(artist) + '/' + slugify(album) + '/' + lyricsPath;
    fetch(url).then(function(r) {
      if (!r.ok) return null;
      return r.text();
    }).then(function(text) {
      var fsText = document.getElementById('urs-fs-lyrics-text');
      var fsWrap = document.getElementById('urs-fs-lyrics');
      if (text && text.trim()) {
        var audioEl = document.getElementById('urs-audio');
        var lrc = (window.URS && window.URS.LRC) ? window.URS.LRC.parse(text) : null;
        if (lrc && audioEl) {
          if (window.__ursLrcAttach && window.__ursLrcAttach.destroy) window.__ursLrcAttach.destroy();
          window.__ursLrcAttach = window.URS.LRC.attach(audioEl, lyricsText, lrc, { mirror: fsText });
        } else {
          lyricsText.textContent = text;
          if (fsText) fsText.textContent = text;
        }
        lyricsEl.style.display = '';
        if (fsWrap) fsWrap.style.display = '';
      } else {
        lyricsText.textContent = 'No lyrics available for this track.';
        if (fsText) fsText.textContent = 'No lyrics available for this track.';
        lyricsEl.style.display = '';
        if (fsWrap) fsWrap.style.display = '';
      }
    }).catch(function() {
      lyricsText.textContent = 'No lyrics available for this track.';
      lyricsEl.style.display = '';
    });
  }

  /* ── Fullscreen lyrics view (Sprint 2) ── */
  function openFullscreen() {
    var fsv = document.getElementById('urs-fullscreen'); if (!fsv) return;
    var npCover = document.getElementById('urs-np-cover');
    var cover = npCover ? npCover.getAttribute('src') : '';
    var fsCover = document.getElementById('urs-fs-cover');
    if (fsCover && cover) fsCover.src = cover;
    if (cover) fsv.style.setProperty('--urs-fs-cover', "url('" + cover + "')");
    var npTitle = document.getElementById('urs-np-title');
    var npArtist = document.getElementById('urs-np-artist');
    var fsTitle = document.getElementById('urs-fs-title');
    var fsArtist = document.getElementById('urs-fs-artist');
    if (fsTitle && npTitle) fsTitle.textContent = npTitle.textContent;
    if (fsArtist && npArtist) fsArtist.textContent = npArtist.textContent;
    var tl = document.getElementById('urs-fs-tracklist');
    if (tl && currentTracks && currentTracks.length) {
      var h = '';
      for (var i = 0; i < currentTracks.length; i++) {
        h += '<button type="button" class="urs-fs-track' + (i === currentTrackIndex ? ' is-playing' : '') + '" data-fs-track="' + i + '">' + escHtml(currentTracks[i].title || ('Track ' + (i + 1))) + '</button>';
      }
      tl.innerHTML = h;
    }
    fsv.style.display = '';
  }
  function closeFullscreen() { var fsv = document.getElementById('urs-fullscreen'); if (fsv) fsv.style.display = 'none'; }
  window.__ursOpenFullscreen = openFullscreen;
  window.__ursCloseFullscreen = closeFullscreen;
  (function bindFullscreen() {
    var npCover = document.getElementById('urs-np-cover');
    if (npCover) { npCover.style.cursor = 'pointer'; npCover.title = 'Open album'; npCover.addEventListener('click', reopenDrawer); }
    var npInfo = document.querySelector('.urs-nowplaying__info');
    if (npInfo) { npInfo.style.cursor = 'pointer'; npInfo.title = 'Open album'; npInfo.addEventListener('click', reopenDrawer); }
    var fsClose = document.getElementById('urs-fs-close');
    if (fsClose) fsClose.addEventListener('click', closeFullscreen);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeFullscreen(); });
    var tl = document.getElementById('urs-fs-tracklist');
    if (tl) tl.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-fs-track]');
      if (!b) return;
      var idx = parseInt(b.getAttribute('data-fs-track'), 10);
      if (!isNaN(idx)) { playTrack(idx); [].forEach.call(tl.querySelectorAll('.urs-fs-track'), function (x, i) { x.classList.toggle('is-playing', i === idx); }); }
    });
  })();

  /* ── Supported By ── */
  function loadSupportedBy(artist, album) {
    if (!supportedByEl) return;
    supportedByEl.style.display = 'none';
    supportedByEl.innerHTML = '';
    var aSlug = slugify(artist);
    var abSlug = slugify(album);
    fetch(WORKER + '/api/likes/' + aSlug + '/' + abSlug)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var fans = data.fans || [];
        currentSupporters = fans;
        if (!fans.length) return;
        var html = '<p class="urs-supported__label">Supported by</p><div class="urs-supported__avatars">';
        var shown = Math.min(fans.length, 10);
        for (var i = 0; i < shown; i++) {
          var f = fans[i];
          if (f.avatar) {
            html += '<img class="urs-supported__avatar" src="' + WORKER + '/cdn/' + escHtml(f.avatar) + '" alt="' + escHtml(f.name) + '" title="' + escHtml(f.name) + '" width="32" height="32">';
          } else {
            var initials = (f.name || '?').charAt(0).toUpperCase();
            var hue = String(f.id || '').split('').reduce(function(a, c) { return a + c.charCodeAt(0); }, 0) % 360;
            html += '<span class="urs-supported__avatar urs-supported__avatar--initials" style="background:hsl(' + hue + ',50%,35%)" title="' + escHtml(f.name) + '">' + initials + '</span>';
          }
        }
        if (fans.length > 10) html += '<span class="urs-supported__more">+' + (fans.length - 10) + '</span>';
        html += '</div>';
        supportedByEl.innerHTML = html;
        supportedByEl.style.display = '';
        if (!supportedByEl._supBound) { supportedByEl._supBound = true; supportedByEl.style.cursor = 'pointer'; supportedByEl.title = 'View all supporters'; supportedByEl.addEventListener('click', function () { if (currentSupporters.length) openSupportersModal(currentSupporters); }); }
      }).catch(function() {});
  }

  /* ── Drawer ── */
  function openDrawer(card) {
    var title = card.dataset.productTitle || '';
    var artist = card.dataset.productArtist || '';
    var image = card.dataset.productImage || '';
    currentAlbumMeta = { title: title, artist: artist, image: image };

    var _phgif = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    if (drawerCover) { drawerCover.src = image || _phgif; drawerCover.alt = image ? title : ''; }
    if (heroBlur && image) heroBlur.style.backgroundImage = 'url(' + image + ')';
    if (drawerTitle) drawerTitle.textContent = title;
    if (drawerArtist) drawerArtist.textContent = artist;
    // ── MEMBER-O5: header meta line "N songs · year" ──
    var albumMetaEl = document.getElementById('urs-drawer-meta');
    var _ebAlbum = document.getElementById('urs-drawer-eyebrow'); if (_ebAlbum) _ebAlbum.textContent = 'Album';
    var albumTrackCount = 0, albumYear = '';
    try { albumTrackCount = JSON.parse(card.dataset.tracks || '[]').length; } catch (e) {}
    // card data-product-id is "r2-YYYY-MM-DD" → first 4-digit run is the year
    var _ym = (card.dataset.productId || '').match(/(\d{4})/);
    if (_ym) albumYear = _ym[1];
    if (albumMetaEl) {
      var metaParts = [];
      if (albumTrackCount) metaParts.push(albumTrackCount + (albumTrackCount === 1 ? ' song' : ' songs'));
      if (albumYear) metaParts.push(albumYear);
      albumMetaEl.textContent = metaParts.join(' · ');
    }
    // ── MEMBER-O5: seed album-page like button ──
    var albumLikeBtn = document.getElementById('urs-albumpage-like');
    if (albumLikeBtn) {
      albumLikeBtn.dataset.artist = artist;
      albumLikeBtn.dataset.album = title;
      albumLikeBtn.dataset.likeKey = likeKey(artist, title);
      var _liked = isLiked(artist, title);
      albumLikeBtn.classList.toggle('urs-liked', _liked);
      var _ic = albumLikeBtn.querySelector('.urs-like__icon');
      if (_ic) _ic.setAttribute('fill', _liked ? 'currentColor' : 'none');
    }
    // ── MEMBER-O5: reveal the now-wired primary play + download (no longer dead) ──
    if (drawerPlay) drawerPlay.style.display = '';
    if (drawerDownload) drawerDownload.style.display = '';
    // ── MEMBER-O5 (P1 fix): reset the empty state; buildTracklist toggles it ──
    var emptyEl = document.getElementById('urs-drawer-tracklist-empty');
    if (emptyEl) emptyEl.style.display = '';
    if (audio) { audio.pause(); audio.src = ''; }
    syncPlayIcons(false);
    if (playerEl) playerEl.style.display = 'none';
    if (tracklistSection) tracklistSection.style.display = 'none';
    if (tracklistEl) tracklistEl.innerHTML = '';
    if (lyricsEl) lyricsEl.style.display = 'none';
    if (supportedByEl) supportedByEl.style.display = 'none';
    currentTracks = [];
    resolvedUrls = {};

    var tracks = [];
    try { tracks = JSON.parse(card.dataset.tracks || '[]'); } catch (e) {}
    buildTracklist(tracks);
    loadSupportedBy(artist, title);

    if (drawer) drawer.classList.add('is-open');
    if (backdrop) backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (closeBtn) closeBtn.focus();

    if (tracks.length) {
      if (tracklistSection) tracklistSection.classList.add('urs-loading');
      preResolveAll(tracks).then(function() {
        if (tracklistSection) tracklistSection.classList.remove('urs-loading');
        loadTrack(0, false);
      });
    }
  }

  function closeDrawer() {
    if (drawer) drawer.classList.remove('is-open');
    if (backdrop) backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* ── Re-reveal the album drawer for the currently playing album (Spotify-style:
     click the now-playing cover/title at the bottom to bring the album panel back).
     Content + audio persist on close, so we just re-add is-open — never rebuild. ── */
  function reopenDrawer() {
    if (!drawer || !currentTracks.length) return;
    drawer.classList.add('is-open');
    if (backdrop) backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (closeBtn) closeBtn.focus();
  }
  window.__ursReopenDrawer = reopenDrawer;

  /* ── Open the album drawer with an arbitrary track list (used by playlists) ──
     Mirrors openDrawer() internals so gating/locked/empty/player all behave the
     same; tracks must be in the same shape r2CardHtml emits:
     { title, url, stream, time, premium, lyrics } */
  function openDrawerWithTracks(title, artist, coverUrl, tracks) {
    title = title || '';
    artist = artist || '';
    var image = coverUrl || '';
    tracks = Array.isArray(tracks) ? tracks : [];
    currentAlbumMeta = { title: title, artist: artist, image: image };

    var _phpl = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    if (drawerCover) { drawerCover.src = image || _phpl; drawerCover.alt = image ? title : ''; }
    var _ebPlaylist = document.getElementById('urs-drawer-eyebrow'); if (_ebPlaylist) _ebPlaylist.textContent = 'Playlist';
    if (heroBlur && image) heroBlur.style.backgroundImage = 'url(' + image + ')';
    if (drawerTitle) drawerTitle.textContent = title;
    if (drawerArtist) drawerArtist.textContent = artist;
    var albumMetaEl = document.getElementById('urs-drawer-meta');
    if (albumMetaEl) {
      albumMetaEl.textContent = tracks.length
        ? (tracks.length + (tracks.length === 1 ? ' song' : ' songs'))
        : '';
    }
    // Playlists are not "albums" → no album-level like target
    var albumLikeBtn = document.getElementById('urs-albumpage-like');
    if (albumLikeBtn) albumLikeBtn.classList.remove('urs-liked');
    if (drawerPlay) drawerPlay.style.display = '';
    if (drawerDownload) drawerDownload.style.display = '';
    var emptyEl = document.getElementById('urs-drawer-tracklist-empty');
    if (emptyEl) emptyEl.style.display = '';
    if (audio) { audio.pause(); audio.src = ''; }
    syncPlayIcons(false);
    if (playerEl) playerEl.style.display = 'none';
    if (tracklistSection) tracklistSection.style.display = 'none';
    if (tracklistEl) tracklistEl.innerHTML = '';
    if (lyricsEl) lyricsEl.style.display = 'none';
    if (supportedByEl) supportedByEl.style.display = 'none';
    currentTracks = [];
    resolvedUrls = {};

    buildTracklist(tracks);

    if (drawer) drawer.classList.add('is-open');
    if (backdrop) backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (closeBtn) closeBtn.focus();

    if (tracks.length) {
      if (tracklistSection) tracklistSection.classList.add('urs-loading');
      preResolveAll(tracks).then(function() {
        if (tracklistSection) tracklistSection.classList.remove('urs-loading');
        loadTrack(0, false);
      });
    }
  }

  /* ── Resolve a raw playlist track ref to a playable album track ──
     ref shape (from worker handleGetPlaylist, raw): { artistSlug, albumSlug, trackId }
     Returns a drawer-shaped track object, or null if unavailable. */
  function resolvePlaylistRef(ref) {
    if (!ref) return null;
    var refArtist = ref.artistSlug;
    var refAlbum = ref.albumSlug;
    var refTrack = ref.trackId;
    if (!refArtist || !refAlbum || !refTrack) return null;
    var album = null;
    for (var j = 0; j < allAlbums.length; j++) {
      var a = allAlbums[j];
      var aArtist = a.artistSlug || slugify(a.artist);
      var aAlbum = a.albumSlug || slugify(a.album);
      if (aArtist === refArtist && aAlbum === refAlbum) { album = a; break; }
    }
    if (!album || !Array.isArray(album.tracks)) return null;
    for (var k = 0; k < album.tracks.length; k++) {
      var t = album.tracks[k];
      var tid = t.id;
      if (!tid) { var pr = parseTrackRef(t.url); tid = pr ? pr.trackId : null; }
      if (tid === refTrack) {
        return { title: t.name, url: '', stream: t.url, time: '', premium: t.premium || false, lyrics: t.lyrics || null };
      }
    }
    return null;
  }

  /* ── Open a playlist (by id) in the album drawer + let the user play it ── */
  function openPlaylistDrawer(plId) {
    if (!plId) return;
    if (!member.id) { openDrawerWithTracks('Playlist', '', '', []); return; }
    ursGetToken().then(function() {
      return fetch(WORKER + '/api/user/' + member.id + '/playlists/' + encodeURIComponent(plId), { headers: ursAuthHeaders() });
    }).then(function(r) { return r.json(); }).then(function(d) {
      var pl = (d && d.playlist) || {};
      var refs = pl.tracks || [];
      var tracks = [];
      for (var i = 0; i < refs.length; i++) {
        var resolved = resolvePlaylistRef(refs[i]);
        if (resolved) tracks.push(resolved);
      }
      var cover = '';
      if (refs[0]) { for (var _ci = 0; _ci < allAlbums.length; _ci++) { var _ca = allAlbums[_ci]; if ((_ca.artistSlug || slugify(_ca.artist)) === refs[0].artistSlug && (_ca.albumSlug || slugify(_ca.album)) === refs[0].albumSlug) { cover = _ca.cover || ''; break; } } }
      openDrawerWithTracks(pl.name || 'Playlist', '', cover || '', tracks);
    }).catch(function() {
      openDrawerWithTracks('Playlist', '', '', []);
    });
  }

  /* ── Playlist card click -> open in album drawer (profile rail + Playlists tab) ── */
  document.addEventListener('click', function (e) {
    var plCard = e.target.closest && e.target.closest('.urs-pl-card');
    if (plCard && plCard.dataset.plId) { e.preventDefault(); openPlaylistDrawer(plCard.dataset.plId); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var plCard = e.target.closest && e.target.closest('.urs-pl-card');
    if (plCard && plCard.dataset.plId) { e.preventDefault(); openPlaylistDrawer(plCard.dataset.plId); }
  });

  /* ── User Profile & Likes ── */
  // Keep the "Welcome back, X" greeting in sync with the profile name (R2), not just
  // Shopify customer.first_name. Only override when we actually have a name, so members
  // without a saved profile name keep the server-rendered first name (no "Member" regression).
  function ursUpdateGreeting() {
    var el = document.querySelector('.urs-welcome__greeting');
    if (!el) return;
    var nm = (userProfile && userProfile.name) || member.name || '';
    if (!nm) return;
    el.textContent = 'Welcome back, ' + nm;
  }
  function loadUserProfile() {
    if (!member.id) return Promise.resolve();
    return ursAuthedFetch(WORKER + '/api/user/' + member.id)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        userProfile = data;
        if (!userProfile.name && member.name) userProfile.name = member.name;
        ursUpdateGreeting();
        renderProfile();
        renderHomeFavorites();
      })
      .catch(function() { userProfile = null; });
  }

  function isLiked(artist, album) {
    if (!userProfile || !userProfile.likes) return false;
    var aSlug = slugify(artist);
    var abSlug = slugify(album);
    for (var i = 0; i < userProfile.likes.length; i++) {
      var l = userProfile.likes[i];
      if (slugify(l.artist) === aSlug && slugify(l.album) === abSlug) return true;
    }
    return false;
  }

  function toggleLike(artist, album, btn) {
    if (!member.id) return;
    btn.disabled = true;
    ursAuthedFetch(WORKER + '/api/user/' + member.id + '/like', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ artist: artist, album: album, name: member.name || '' })
    })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        btn.disabled = false;
        var svgEl = btn.querySelector('.urs-like__icon');
        if (data.liked) {
          btn.classList.add('urs-liked');
          if (svgEl) svgEl.setAttribute('fill', 'currentColor');
          if (!userProfile) userProfile = { likes: [] };
          if (!userProfile.likes) userProfile.likes = [];
          userProfile.likes.unshift({ artist: artist, album: album, date: new Date().toISOString().slice(0, 10) });
        } else {
          btn.classList.remove('urs-liked');
          if (svgEl) svgEl.setAttribute('fill', 'none');
          if (userProfile && userProfile.likes) {
            userProfile.likes = userProfile.likes.filter(function(l) {
              return !(slugify(l.artist) === slugify(artist) && slugify(l.album) === slugify(album));
            });
          }
        }
        var countEl = btn.querySelector('.urs-like__count');
        if (countEl && data.likeCount !== undefined) countEl.textContent = data.likeCount || '';
        // Sync all matching like buttons
        var allBtns = document.querySelectorAll('.urs-like__btn[data-like-key="' + likeKey(artist, album) + '"]');
        for (var i = 0; i < allBtns.length; i++) {
          if (allBtns[i] === btn) continue;
          var s = allBtns[i].querySelector('.urs-like__icon');
          var c = allBtns[i].querySelector('.urs-like__count');
          if (data.liked) { allBtns[i].classList.add('urs-liked'); if (s) s.setAttribute('fill', 'currentColor'); }
          else { allBtns[i].classList.remove('urs-liked'); if (s) s.setAttribute('fill', 'none'); }
          if (c && data.likeCount !== undefined) c.textContent = data.likeCount || '';
        }
        renderHomeFavorites();
        renderProfileCollection();
      })
      .catch(function() { btn.disabled = false; });
  }

  function loadLikesCounts(albums) {
    if (!albums.length) return Promise.resolve();
    var slugs = [];
    for (var i = 0; i < albums.length; i++) slugs.push(likeKey(albums[i].artist, albums[i].album));
    return fetch(WORKER + '/api/likes-batch?albums=' + slugs.join(','))
      .then(function(r) { return r.json(); })
      .then(function(data) {
        likeCountsCache = data.counts || {};
        var btns = document.querySelectorAll('.urs-like__btn');
        for (var j = 0; j < btns.length; j++) {
          var key = btns[j].dataset.likeKey;
          if (key && likeCountsCache[key] !== undefined) {
            var c = btns[j].querySelector('.urs-like__count');
            if (c) c.textContent = likeCountsCache[key] || '';
          }
        }
      })
      .catch(function() {});
  }

  /* ── Avatar Upload ── */
  var avatarInput = document.getElementById('urs-avatar-input');
  if (avatarInput) {
    avatarInput.addEventListener('change', function() {
      var file = this.files && this.files[0];
      if (!file || !member.id) return;
      if (file.size > 2 * 1024 * 1024) { alert('Max 2MB'); return; }
      var fd = new FormData();
      fd.append('file', file);
      ursAuthedFetch(WORKER + '/api/user/' + member.id + '/avatar', {
        method: 'POST',
        body: fd
      })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (data.ok && data.url) {
            var img = document.getElementById('urs-profile-avatar-img');
            var initials = document.getElementById('urs-profile-avatar-initials');
            if (img) { img.src = data.url; img.style.display = ''; }
            if (initials) initials.style.display = 'none';
            if (userProfile) userProfile.avatar = data.url;
          }
        })
        .catch(function(e) { console.error('[URS] avatar error:', e); });
    });
  }

  /* ── Download helper ── */
  function downloadFile(url, filename) {
    // Use worker ?dl=1&name= so the server forces Content-Disposition with the .mp3
    // extension (cross-origin a.download is ignored by browsers -> was saving as .acf).
    var base = String(filename || 'track').replace(/\.[a-z0-9]+$/i, '');
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    var dlUrl = url + sep + 'dl=1&name=' + encodeURIComponent(base);
    var a = document.createElement('a');
    a.href = dlUrl;
    a.setAttribute('download', base + '.mp3');
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    return Promise.resolve();
  }

  function downloadAllSequential(tracks, index) {
    if (index >= tracks.length) return;
    var t = tracks[index];
    if (!t.url && !t.stream) { downloadAllSequential(tracks, index + 1); return; }
    var src = t.stream || t.url;
    downloadFile(src, (index + 1) + ' - ' + t.name + '.mp3').then(function() {
      setTimeout(function() { downloadAllSequential(tracks, index + 1); }, 500);
    });
  }

  /* ── R2 Card HTML ── */
  function getCoverUrl(album) {
    if (album.cover && album.cover.indexOf('blob:') !== 0 && album.cover.indexOf('data:') !== 0) return album.cover;
    if (album.coverR2) return album.coverR2;
    var s = slugify(album.artist);
    var a = slugify(album.album);
    if (s && a) return WORKER + '/cdn/' + s + '/' + a + '/cover.jpg';
    return '';
  }

  function r2CardHtml(album, opts) {
    opts = opts || {};
    var cover = getCoverUrl(album);
    var coverImg = cover
      ? '<img class="urs-card__image" src="' + cover + '" alt="' + escHtml(album.album) + '" loading="lazy" onerror="this.style.display=\'none\';this.nextElementSibling.style.display=\'block\'">' +
        '<div style="background:var(--member-surface-3);width:100%;height:100%;display:none"></div>'
      : '<div class="urs-card__image" style="background:var(--member-surface-3);width:100%;height:100%"></div>';
    var tracksJson = JSON.stringify((album.tracks || []).map(function(t) {
      return { title: t.name, url: '', stream: t.url, time: '', premium: t.premium || false, lyrics: t.lyrics || null };
    }));
    var lk = likeKey(album.artist, album.album);
    var liked = isLiked(album.artist, album.album);
    var count = likeCountsCache[lk] || 0;
    var likeHtml = '';
    if (!opts.noLike) {
      likeHtml = '<button class="urs-like__btn' + (liked ? ' urs-liked' : '') + '" data-like-key="' + lk + '" data-artist="' + escHtml(album.artist) + '" data-album="' + escHtml(album.album) + '" type="button" aria-label="Like"' + (!member.id ? ' disabled' : '') + '>' +
        '<svg class="urs-like__icon" viewBox="0 0 24 24" fill="' + (liked ? 'currentColor' : 'none') + '" stroke="currentColor" stroke-width="2" width="16" height="16"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>' +
        '<span class="urs-like__count">' + (count || '') + '</span></button>';
    }
    var _locked = albumLocked(album);
    var _needT = _locked ? albumMinTier(album) : '';
    return '<article class="urs-card' + (_locked ? ' urs-card--locked' : '') + '"' +
      ' data-locked="' + (_locked ? '1' : '') + '" data-need-tier="' + escHtml(_needT) + '"' +
      ' data-product-title="' + escHtml(album.album) + '"' +
      ' data-product-artist="' + escHtml(album.artist) + '"' +
      ' data-product-image="' + escHtml(cover) + '"' +
      ' data-product-id="r2-' + escHtml(album.date) + '"' +
      ' data-tracks="' + escHtml(tracksJson) + '"' +
      ' tabindex="0" role="button"' +
      ' aria-label="' + escHtml(album.album) + ' - ' + escHtml(album.artist) + '">' +
      '<div class="urs-card__cover">' + coverImg +
      '<div class="urs-card__play" aria-hidden="true"><span class="urs-card__play-btn">' +
      '<svg class="urs-card__play-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>' +
      '</span></div>' + (_locked ? '<div class="urs-card__lock" aria-hidden="true">' + URS_LOCK_SVG + '<span class="urs-card__lock-pill">' + escHtml(tierCap(_needT)) + '</span></div>' : '') + '</div>' +
      '<div class="urs-card__info">' +
      '<p class="urs-card__title">' + escHtml(album.album) + '</p>' +
      '<p class="urs-card__artist">' + escHtml(album.artist) + '</p>' +
      likeHtml +
      '</div></article>';
  }

  /* ── Home hero (Onda 1b) ── */
  function renderHomeHero(albums) {
    var hero = document.getElementById('urs-hero');
    if (!hero) return;
    if (!albums || !albums.length) { hero.innerHTML = ''; return; }
    var sorted = albums.slice().sort(function (x, y) { return String(y.date || '').localeCompare(String(x.date || '')); });
    var feat = sorted.slice(0, 3);
    function slideInner(a) {
      var cover = getCoverUrl(a);
      var _cpos = a.cover_pos || '50% 50%';
      var tracksJson = JSON.stringify((a.tracks || []).map(function (t) { return { title: t.name, url: '', stream: t.url, time: '', premium: t.premium || false, lyrics: t.lyrics || null }; }));
      var locked = albumLocked(a); var need = locked ? albumMinTier(a) : '';
      var playLabel = locked
        ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18" aria-hidden="true"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg> Unlock with ' + tierCap(need)
        : '<svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg> Play album';
      return '<div class="urs-dash-hero" data-product-title="' + escHtml(a.album) + '" data-product-artist="' + escHtml(a.artist) + '" data-product-image="' + escHtml(cover) + '" data-product-id="r2-' + escHtml(a.date) + '" data-tracks="' + escHtml(tracksJson) + '" data-locked="' + (locked ? '1' : '') + '" data-need="' + escHtml(need) + '">' +
        (cover ? '<div class="urs-dash-hero__bg" style="background-image:url(' + cover + ');background-position:' + _cpos + '"></div>' : '') +
        '<div class="urs-dash-hero__scrim"></div>' +
        '<div class="urs-dash-hero__inner">' +
          (cover ? '<img class="urs-dash-hero__cover" src="' + cover + '" alt="" loading="eager" style="object-position:' + _cpos + '">' : '') +
          '<div class="urs-dash-hero__meta">' +
            '<p class="urs-dash-hero__eyebrow">New release</p>' +
            '<h2 class="urs-dash-hero__title">' + escHtml(a.album) + '</h2>' +
            '<p class="urs-dash-hero__artist">' + escHtml(a.artist) + '</p>' +
            '<p class="urs-dash-hero__metaline">' + (a.tracks ? a.tracks.length : 0) + ' tracks' + (a.date ? ' · ' + String(a.date).slice(0, 4) : '') + '</p>' +
            '<div class="urs-dash-hero__actions">' +
              '<button type="button" class="urs-dash-hero__play" data-hero-play>' + playLabel + '</button>' +
              '<button type="button" class="urs-dash-hero__info" data-hero-info><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4M12 8h.01"/></svg> More info</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
    }
    if (feat.length < 2) {
      hero.innerHTML = slideInner(feat[0]);
    } else {
      var slides = '', dots = '';
      for (var i = 0; i < feat.length; i++) {
        slides += '<div class="urs-herocar__slide' + (i === 0 ? ' is-active' : '') + '">' + slideInner(feat[i]) + '</div>';
        dots += '<button type="button" class="urs-herocar__dot' + (i === 0 ? ' is-active' : '') + '" data-dot="' + i + '" aria-label="Release ' + (i + 1) + '"><i class="urs-herocar__fill"></i></button>';
      }
      hero.innerHTML = '<div class="urs-herocar"><div class="urs-herocar__track">' + slides + '</div><div class="urs-herocar__dots">' + dots + '</div></div>';
    }
    var heroes = hero.querySelectorAll('.urs-dash-hero');
    for (var h = 0; h < heroes.length; h++) {
      (function (heroEl) {
        var locked = heroEl.getAttribute('data-locked') === '1';
        var need = heroEl.getAttribute('data-need') || '';
        var act = function (e) { e.preventDefault(); if (locked) { openUpgrade(need); } else { openDrawer(heroEl); } };
        var pb = heroEl.querySelector('[data-hero-play]'); if (pb) pb.addEventListener('click', act);
        var ib = heroEl.querySelector('[data-hero-info]'); if (ib) ib.addEventListener('click', act);
      })(heroes[h]);
    }
    var car = hero.querySelector('.urs-herocar');
    if (car) {
      var slidesEls = car.querySelectorAll('.urs-herocar__slide');
      var dotsEls = car.querySelectorAll('.urs-herocar__dot');
      var idx = 0;
      var go = function (n) { idx = (n + slidesEls.length) % slidesEls.length; for (var k = 0; k < slidesEls.length; k++) { slidesEls[k].classList.toggle('is-active', k === idx); if (dotsEls[k]) dotsEls[k].classList.toggle('is-active', k === idx); } };
      var advance = function () { if (!car.classList.contains('is-paused')) go(idx + 1); };
      car.addEventListener('animationend', function (e) { if (e.animationName === 'ursHeroFill') advance(); });
      for (var d = 0; d < dotsEls.length; d++) { (function (n) { dotsEls[n].addEventListener('click', function () { go(n); }); })(d); }
      car.addEventListener('mouseenter', function () { car.classList.add('is-paused'); }); car.addEventListener('mouseleave', function () { car.classList.remove('is-paused'); });
    }
  }

  /* -- Home Section -- */
  function renderHome(albums) {
    var container = document.getElementById('urs-r2-rails');
    if (!container) return;
    if (!albums.length) { container.innerHTML = '<p class="urs-text-muted">No albums yet.</p>'; return; }

    renderHomeHero(albums);

    /* Personalized by tier: feature what THIS member can play; group locked at the bottom */
    var accessible = [], locked = [];
    for (var i = 0; i < albums.length; i++) { (albumLocked(albums[i]) ? locked : accessible).push(albums[i]); }
    var personalize = locked.length > 0;

    function railOpen(title, seeAttr) {
      return '<section class="urs-rail"><div class="urs-rail__header">' +
        '<h2 class="urs-rail__title">' + escHtml(title) + '</h2>' +
        '<a href="#catalog" class="urs-rail__see-all" ' + seeAttr + '>See all</a>' +
        '</div><div class="urs-rail__scroll">';
    }
    function railCards(arr, n) { var h = ''; for (var x = 0; x < Math.min(arr.length, n || 8); x++) h += r2CardHtml(arr[x]); return h; }

    var html = '';
    html += '<div id="urs-home-tierbar">' + tierBannerHtml() + '</div>';

    /* Favorites on top (populated async by renderHomeFavorites) — Leo's order */
    html += '<div id="urs-home-favorites"></div>';

    /* New Releases — accessible-first, excluding club-exclusive albums (own rail below) */
    var ordered = (personalize ? accessible.concat(locked) : albums).filter(function (a) { return !a.exclusive; });
    html += railOpen('New Releases', 'data-see-all=""') + railCards(ordered, 12) + '</div></section>';

    /* Exclusive Unreal Rock+ Albums — club-only curated category */
    var exclusive = albums.filter(function (a) { return a.exclusive; });
    if (exclusive.length) {
      html += railOpen('Exclusive Unreal Rock+ Albums', 'data-see-all=""') + railCards(exclusive, 12) + '</div></section>';
    }

    /* Artist rails (the rest) — from the accessible pool when personalizing */
    var pool = personalize ? accessible : albums;
    var artistMap = {};
    for (var j = 0; j < pool.length; j++) { var art = pool[j].artist; if (!artistMap[art]) artistMap[art] = []; artistMap[art].push(pool[j]); }
    var artists = Object.keys(artistMap);
    for (var k = 0; k < artists.length; k++) {
      if (artistMap[artists[k]].length < 3) continue;
      html += railOpen(artists[k], 'data-see-all-artist="' + escHtml(artists[k]) + '"') + railCards(artistMap[artists[k]], 8) + '</div></section>';
    }

    if (locked.length) {
      var need = albumMinTier(locked[0]);
      html += '<section class="urs-rail urs-rail--locked"><div class="urs-rail__header">' +
        '<h2 class="urs-rail__title">Unlock ' + locked.length + ' more with ' + tierCap(need) + '</h2>' +
        '<a href="/pages/club#tiers" class="urs-rail__see-all">Upgrade</a>' +
        '</div><div class="urs-rail__scroll">' + railCards(locked, 12) + '</div></section>';
    }

    container.innerHTML = html;
    renderHomeFavorites();
  }

  function renderHomeFavorites() {
    var container = document.getElementById('urs-home-favorites');
    if (!container) return;
    if (!userProfile || !userProfile.likes || !userProfile.likes.length) {
      container.innerHTML = '';
      return;
    }
    var html = '<section class="urs-rail"><div class="urs-rail__header">' +
      '<h2 class="urs-rail__title">Your Favorites</h2>' +
      '<a href="#profile" class="urs-rail__see-all" data-section="profile">See all</a>' +
      '</div><div class="urs-rail__scroll">';
    var shown = 0;
    for (var i = 0; i < userProfile.likes.length && shown < 8; i++) {
      var like = userProfile.likes[i];
      var album = null;
      for (var j = 0; j < allAlbums.length; j++) {
        if (slugify(allAlbums[j].artist) === slugify(like.artist) && slugify(allAlbums[j].album) === slugify(like.album)) {
          album = allAlbums[j]; break;
        }
      }
      if (album) { html += r2CardHtml(album); shown++; }
    }
    html += '</div></section>';
    container.innerHTML = shown > 0 ? html : '';
  }

  /* ── Catalog Section ── */
  /* ── Spotify-style browse-by-section (genre tiles) ── */
  function normGenre(g) {
    g = (g || '').trim();
    if (!g) return 'Other';
    return g.toLowerCase().split(/\s+/).map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join(' ');
  }
  var URS_TILE_PALETTE = ['#c0367a','#4f5bbf','#7b3f9e','#d2492f','#1f7a4d','#2b6cb0','#a8305f','#c2700a','#0e7c86','#6d28d9','#b01246','#2f7a52','#9333a8','#b5491b'];
  function ursTileColor(name) { var h = 0; for (var i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0; return URS_TILE_PALETTE[h % URS_TILE_PALETTE.length]; }
  function buildGenreSections(albums) {
    var map = {};
    for (var i = 0; i < albums.length; i++) { var g = normGenre(albums[i].genre); (map[g] = map[g] || []).push(albums[i]); }
    return Object.keys(map).map(function (g) { return { genre: g, count: map[g].length, cover: getCoverUrl(map[g][0]), albums: map[g] }; })
      .sort(function (a, b) { if (a.genre === 'Other') return 1; if (b.genre === 'Other') return -1; return b.count - a.count; });
  }
  function ursTileHtml(o) {
    var art = o.cover ? '<img class="urs-gtile__art" src="' + escHtml(o.cover) + '" alt="" loading="lazy">' : '';
    var sub = (o.count != null) ? (o.count + (o.count === 1 ? ' album' : ' albums')) : (o.sub || '');
    return '<button type="button" class="urs-gtile" data-gtile="' + escHtml(o.key) + '" style="--gtile-c:' + o.color + '" aria-label="' + escHtml(o.title) + '">' +
      '<span class="urs-gtile__title">' + escHtml(o.title) + '</span>' +
      (sub ? '<span class="urs-gtile__count">' + escHtml(sub) + '</span>' : '') + art + '</button>';
  }
  function renderSectionTiles() {
    var host = document.getElementById('urs-genre-sections');
    if (!host) return;
    var recent = allAlbums.slice().sort(function (a, b) { return (b.date || '').localeCompare(a.date || ''); });
    var html = '';
    html += ursTileHtml({ key: '__all', title: 'All albums', count: allAlbums.length, cover: recent[0] && getCoverUrl(recent[0]), color: '#A855F7' });
    html += ursTileHtml({ key: '__new', title: 'New releases', sub: 'new', cover: recent[0] && getCoverUrl(recent[0]), color: '#6d28d9' });
    html += ursTileHtml({ key: '__liked', title: 'Most liked', sub: 'trending', cover: recent[1] && getCoverUrl(recent[1]), color: '#be123c' });
    var secs = buildGenreSections(allAlbums);
    for (var i = 0; i < secs.length; i++) html += ursTileHtml({ key: 'g:' + secs[i].genre, title: secs[i].genre, count: secs[i].count, cover: secs[i].cover, color: ursTileColor(secs[i].genre) });
    host.innerHTML = html;
  }
  function ursSetCatalogFilters(show) { var el = document.querySelector('#urs-section-catalog .urs-catalog__filters'); if (el) el.style.display = show ? '' : 'none'; }
  function ursCatalogTitle(text, show) { var h = document.querySelector('#urs-section-catalog .urs-catalog__header .urs-rail__title'); if (h) { h.textContent = text; h.style.display = show ? '' : 'none'; } }
  function showBrowse() {
    catalogView = 'browse'; resultsSource = '';
    var gs = document.getElementById('urs-genre-sections'); if (gs) gs.style.display = '';
    var sh = document.getElementById('urs-section-head'); if (sh) sh.style.display = 'none';
    if (catalogGrid) catalogGrid.style.display = 'none';
    ursSetCatalogFilters(false); ursCatalogTitle('Browse', true);
    if (searchInput) searchInput.value = '';
    if (searchClear) searchClear.style.display = 'none';
    if (searchEmpty) searchEmpty.style.display = 'none';
  }
  function openCatalogResults(title, subset, source) {
    catalogView = 'results'; resultsSource = source || 'genre';
    var gs = document.getElementById('urs-genre-sections'); if (gs) gs.style.display = 'none';
    var sh = document.getElementById('urs-section-head'); if (sh) sh.style.display = 'flex';
    var st = document.getElementById('urs-section-title'); if (st) st.textContent = title;
    var sc = document.getElementById('urs-section-count'); if (sc) sc.textContent = subset.length + (subset.length === 1 ? ' album' : ' albums');
    if (catalogGrid) catalogGrid.style.display = '';
    ursSetCatalogFilters(true); ursCatalogTitle('', false);
    renderCatalog(subset); filterCatalog();
  }
  function openGenreTile(key) {
    if (key === '__all') { if (sortFilter) sortFilter.value = 'recent'; openCatalogResults('All albums', allAlbums, 'genre'); }
    else if (key === '__new') { if (sortFilter) sortFilter.value = 'recent'; openCatalogResults('New releases', allAlbums, 'genre'); }
    else if (key === '__liked') { if (sortFilter) sortFilter.value = 'likes'; openCatalogResults('Most liked', allAlbums, 'genre'); }
    else if (key.indexOf('g:') === 0) { var g = key.slice(2); openCatalogResults(g, allAlbums.filter(function (a) { return normGenre(a.genre) === g; }), 'genre'); }
  }
  function renderCatalog(albums) {
    var grid = document.getElementById('urs-catalog-grid');
    if (!grid) return;
    if (!albums.length) { grid.innerHTML = '<p class="urs-text-muted">No albums yet.</p>'; return; }
    var _ordered = albums.slice().sort(function (a, b) { return (albumLocked(a) ? 1 : 0) - (albumLocked(b) ? 1 : 0); });
    var html = '';
    for (var i = 0; i < _ordered.length; i++) html += r2CardHtml(_ordered[i]);
    grid.innerHTML = html;

    if (artistFilter) {
      var artistSet = {};
      for (var j = 0; j < albums.length; j++) artistSet[albums[j].artist] = true;
      var artistNames = Object.keys(artistSet).sort();
      var optHtml = '<option value="">All Artists</option>';
      for (var k = 0; k < artistNames.length; k++) {
        optHtml += '<option value="' + escHtml(artistNames[k]) + '">' + escHtml(artistNames[k]) + '</option>';
      }
      artistFilter.innerHTML = optHtml;
    }
  }

  function filterCatalog() {
    if (!catalogGrid) return;
    var q = (searchInput ? searchInput.value : '').toLowerCase().trim();
    var artistVal = artistFilter ? artistFilter.value : '';
    var sortVal = sortFilter ? sortFilter.value : 'recent';
    var cards = catalogGrid.querySelectorAll('.urs-card');
    var visible = 0;
    var cardArr = [];
    for (var i = 0; i < cards.length; i++) cardArr.push(cards[i]);

    for (var j = 0; j < cardArr.length; j++) {
      var c = cardArr[j];
      var t = (c.dataset.productTitle || '').toLowerCase();
      var a = c.dataset.productArtist || '';
      var matchSearch = !q || t.indexOf(q) !== -1 || a.toLowerCase().indexOf(q) !== -1;
      var matchArtist = !artistVal || a === artistVal;
      var show = matchSearch && matchArtist;
      c.style.display = show ? '' : 'none';
      c.style.order = '';
      if (show) visible++;
    }

    if (sortVal === 'az') {
      var vis = cardArr.filter(function(c) { return c.style.display !== 'none'; });
      vis.sort(function(a, b) { return (a.dataset.productTitle || '').localeCompare(b.dataset.productTitle || ''); });
      for (var s = 0; s < vis.length; s++) vis[s].style.order = s;
    } else if (sortVal === 'likes') {
      var vis2 = cardArr.filter(function(c) { return c.style.display !== 'none'; });
      vis2.sort(function(a, b) {
        var la = a.querySelector('.urs-like__count');
        var lb = b.querySelector('.urs-like__count');
        var ca = la ? parseInt(la.textContent || '0', 10) : 0;
        var cb = lb ? parseInt(lb.textContent || '0', 10) : 0;
        return cb - ca;
      });
      for (var s2 = 0; s2 < vis2.length; s2++) vis2[s2].style.order = s2;
    }

    if (searchClear) searchClear.style.display = q ? '' : 'none';
    if (searchEmpty) searchEmpty.style.display = (visible === 0) ? '' : 'none';
  }

  /* ── Downloads Section ── */
  function renderDownloads(albums) {
    var container = document.getElementById('urs-r2-downloads');
    if (!container) return;
    if (!albums.length) { container.innerHTML = '<p class="urs-text-muted">No albums yet.</p>'; return; }

    var isLegend = canDownload();
    var html = '';
    if (!isLegend) {
      html += '<div class="urs-downloads__gate"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>' +
        '<p>Downloads are not available on your plan right now.</p>' +
        '</div>';
    }

    for (var i = 0; i < albums.length; i++) {
      var album = albums[i];
      var cover = getCoverUrl(album);
      var trackCount = album.tracks ? album.tracks.length : 0;
      html += '<div class="urs-dl-card" data-dl-index="' + i + '">' +
        '<div class="urs-dl-card__header">' +
        '<img class="urs-dl-card__cover" src="' + escHtml(cover) + '" alt="" width="64" height="64" loading="lazy">' +
        '<div class="urs-dl-card__info">' +
        '<p class="urs-dl-card__title">' + escHtml(album.album) + ' — ' + escHtml(album.artist) + '</p>' +
        '<p class="urs-dl-card__meta">' + trackCount + ' tracks</p>' +
        '</div>' +
        '<div class="urs-dl-card__actions">';
      if (isLegend) {
        html += '<button class="urs-dl-card__btn urs-dl-card__btn--all" data-dl-all="' + i + '" type="button">Download All</button>';
      }
      html += '<button class="urs-dl-card__btn urs-dl-card__toggle" data-dl-toggle="' + i + '" type="button" aria-expanded="false">Tracks ▾</button>' +
        '</div></div>' +
        '<div class="urs-dl-card__tracks" id="urs-dl-tracks-' + i + '" style="display:none"><ol class="urs-dl-card__tracklist">';

      for (var j = 0; j < trackCount; j++) {
        var t = album.tracks[j];
        var isPremium = t.premium && !canStream(t);
        html += '<li class="urs-dl-card__track' + (isPremium ? ' urs-dl-card__track--locked' : '') + '">' +
          '<span class="urs-dl-card__track-num">' + (j + 1) + '</span>' +
          '<span class="urs-dl-card__track-name">' + escHtml(t.name) + '</span>';
        if (isPremium) {
          html += '<span class="urs-track__lock"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg> Premium</span>';
        } else if (isLegend) {
          html += '<button class="urs-dl-card__dl-btn" data-dl-album="' + i + '" data-dl-track="' + j + '" type="button">Download</button>';
        }
        html += '</li>';
      }
      html += '</ol></div></div>';
    }
    container.innerHTML = html;
  }

  /* ── Profile Section ── */
  function renderProfile() {
    var nameEl = document.getElementById('urs-profile-name');
    var tierEl = document.getElementById('urs-profile-tier');
    var avatarImg = document.getElementById('urs-profile-avatar-img');
    var avatarInitials = document.getElementById('urs-profile-avatar-initials');

    if (avatarInitials) {
      var name = (userProfile && userProfile.name) || member.name || 'M';
      avatarInitials.textContent = name.charAt(0).toUpperCase();
      var hue = String(member.id || '').split('').reduce(function(a, c) { return a + c.charCodeAt(0); }, 0) % 360;
      avatarInitials.style.background = 'hsl(' + hue + ',50%,35%)';
    }

    if (userProfile && userProfile.avatar) {
      var src = userProfile.avatar;
      if (src.indexOf('http') !== 0) src = WORKER + '/cdn/' + src;
      if (avatarImg) { avatarImg.src = src; avatarImg.style.display = ''; }
      if (avatarInitials) avatarInitials.style.display = 'none';
    }

    if (tierEl) {
      var tierHtml = '';
      if (member.tier === 'legend') tierHtml = '<span class="urs-tier-badge urs-tier-badge--insider">⭐ Insider</span>';
      else if (member.tier === 'insider') tierHtml = '<span class="urs-tier-badge urs-tier-badge--insider">⭐ Insider</span>';
      else tierHtml = '<span class="urs-tier-badge">Listener</span>';
      tierEl.innerHTML = tierHtml;
    }

    // #9 mirror identity into the sidebar profile widget
    var sName = document.getElementById('urs-sidebar-name');
    var sInit = document.getElementById('urs-sidebar-initials');
    var sImg = document.getElementById('urs-sidebar-avatar-img');
    var sTier = document.getElementById('urs-sidebar-tier');
    var dispName = (userProfile && userProfile.name) || member.name || 'Member';
    if (sName) sName.textContent = dispName;
    if (nameEl) nameEl.textContent = dispName;
    if (sInit) {
      sInit.textContent = dispName.charAt(0).toUpperCase();
      var sHue = String(member.id || '').split('').reduce(function(a, c) { return a + c.charCodeAt(0); }, 0) % 360;
      sInit.style.background = 'hsl(' + sHue + ',50%,35%)';
    }
    if (userProfile && userProfile.avatar && sImg) {
      var s2 = userProfile.avatar; if (s2.indexOf('http') !== 0) s2 = WORKER + '/cdn/' + s2;
      sImg.src = s2; sImg.style.display = ''; if (sInit) sInit.style.display = 'none';
    }
    if (sTier) {
      sTier.textContent = member.tier === 'insider' || member.tier === 'legend' ? 'Insider' : 'Listener';
      sTier.className = 'urs-sidebar__profile-tier urs-sidebar__profile-tier--' + (member.tier || 'listener');
    }

    renderProfileStats();
    renderProfileCollection();
    loadProfilePlaylists();
  }

  /* ── Profile display-name inline edit (wires the pencil + form already in markup) ── */
  (function wireNameEdit() {
    var row = document.getElementById('urs-profile-name-row');
    var form = document.getElementById('urs-profile-name-form');
    var editBtn = document.getElementById('urs-profile-name-edit');
    var input = document.getElementById('urs-profile-name-input');
    var saveBtn = document.getElementById('urs-profile-name-save');
    var cancelBtn = document.getElementById('urs-profile-name-cancel');
    if (!row || !form || !editBtn || !input || !saveBtn || !cancelBtn) return;
    function showForm() {
      input.value = (userProfile && userProfile.name) || member.name || '';
      row.style.display = 'none'; form.style.display = '';
      input.focus(); input.select();
    }
    function hideForm() { form.style.display = 'none'; row.style.display = ''; }
    function save() {
      var nm = (input.value || '').trim().slice(0, 40);
      if (!nm || !member.id) { hideForm(); return; }
      saveBtn.disabled = true;
      ursGetToken().then(function () {
        return fetch(WORKER + '/api/user/' + member.id, { method: 'POST', headers: ursAuthHeaders({ 'Content-Type': 'application/json' }), body: JSON.stringify({ name: nm }) });
      }).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
        saveBtn.disabled = false;
        if (!d || !d.ok) { hideForm(); return; }
        var saved = (d.user && d.user.name) || nm;
        if (!userProfile) userProfile = {};
        userProfile.name = saved;
        member.name = saved;
        ursUpdateGreeting();
        try { window.URS_CUSTOMER_NAME = saved; } catch (e) {}
        var myAv = document.getElementById('urs-wall-myavatar');
        if (myAv) myAv.textContent = saved.slice(0, 1).toUpperCase();
        hideForm();
        renderProfile();
      }).catch(function () { saveBtn.disabled = false; hideForm(); });
    }
    editBtn.addEventListener('click', showForm);
    cancelBtn.addEventListener('click', hideForm);
    saveBtn.addEventListener('click', save);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); save(); }
      else if (e.key === 'Escape') { e.preventDefault(); hideForm(); }
    });
  })();

  /* ── Bandcamp-style profile stats row (#5) ── */
  function renderProfileStats() {
    var statsEl = document.getElementById('urs-profile-stats');
    if (!statsEl) return;
    var likeCount = (userProfile && userProfile.likes) ? userProfile.likes.length : 0;
    var plCount = profilePlaylistCount; // resolved by loadProfilePlaylists()
    var since = '';
    var sinceEl = document.getElementById('urs-profile-since');
    if (sinceEl && sinceEl.textContent) since = sinceEl.textContent.replace(/^Member since\s*/i, '').trim();
    var items = [];
    items.push('<span class="urs-profile__stat"><strong>' + plCount + '</strong> ' + (plCount === 1 ? 'playlist' : 'playlists') + '</span>');
    items.push('<span class="urs-profile__stat"><strong>' + likeCount + '</strong> liked ' + (likeCount === 1 ? 'song' : 'songs') + '</span>');
    if (since && since.toLowerCase() !== 'member') items.push('<span class="urs-profile__stat urs-profile__stat--since">since <strong>' + escHtml(since) + '</strong></span>');
    // keep the share button (rendered separately in markup) — inject stats before it
    var shareBtn = document.getElementById('urs-profile-share');
    statsEl.innerHTML = items.join('<span class="urs-profile__stat-dot" aria-hidden="true">·</span>');
    if (shareBtn) statsEl.appendChild(shareBtn);
  }

  /* ── Your Playlists rail in profile (GET /api/user/{id}/playlists) ── */
  var profilePlaylistCount = 0;
  var profilePlLoaded = false;
  function renderProfilePlaylists(list) {
    var wrap = document.getElementById('urs-profile-playlists');
    var grid = document.getElementById('urs-profile-playlists-grid');
    if (!grid) return;
    if (!list || !list.length) {
      if (wrap) wrap.style.display = 'none';
      return;
    }
    if (wrap) wrap.style.display = '';
    var titleEl = document.getElementById('urs-profile-playlists-title');
    if (titleEl) titleEl.textContent = 'Your Playlists — ' + list.length;
    var h = '';
    for (var i = 0; i < list.length; i++) {
      var p = list[i];
      var cover = plCoverHtml(p);
      var sub = (p.trackCount || 0) + ' track' + (p.trackCount === 1 ? '' : 's') + (p.visibility === 'private' ? ' · Private' : '');
      h += '<div class="urs-pl-card" data-pl-id="' + escHtml(p.id) + '" role="button" tabindex="0">' + cover +
        '<div class="urs-pl-card__meta"><span class="urs-pl-card__name">' + escHtml(p.name || 'Untitled') + '</span>' +
        '<span class="urs-pl-card__count">' + sub + '</span></div></div>';
    }
    grid.innerHTML = h;
  }
  function loadProfilePlaylists() {
    var grid = document.getElementById('urs-profile-playlists-grid');
    if (!member.id || !grid || profilePlLoaded) {
      if (!member.id) { var w = document.getElementById('urs-profile-playlists'); if (w) w.style.display = 'none'; }
      return;
    }
    profilePlLoaded = true;
    ursGetToken().then(function () {
      return fetch(WORKER + '/api/user/' + member.id + '/playlists', { headers: ursAuthHeaders() });
    }).then(function (r) { return r.json(); }).then(function (d) {
      var list = (d && d.playlists) || [];
      profilePlaylistCount = list.length;
      renderProfilePlaylists(list);
      renderProfileStats();
    }).catch(function () {
      profilePlLoaded = false; // allow retry next render
    });
  }

  /* ── Copy public profile link (#5: name+photo+playlists+liked, NEVER email) ── */
  var profileShareBtn = document.getElementById('urs-profile-share');
  if (profileShareBtn) {
    profileShareBtn.addEventListener('click', function () {
      if (!member.id) return;
      var url = window.location.origin + '/pages/member-profile?id=' + encodeURIComponent(member.id);
      var labelEl = document.getElementById('urs-profile-share-label');
      function flash() {
        if (!labelEl) return;
        var prev = labelEl.textContent;
        labelEl.textContent = 'Link copied!';
        profileShareBtn.classList.add('is-copied');
        setTimeout(function () { labelEl.textContent = prev || 'Copy public profile link'; profileShareBtn.classList.remove('is-copied'); }, 1800);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(flash).catch(function () { window.prompt('Copy your public profile link:', url); });
      } else {
        window.prompt('Copy your public profile link:', url);
      }
    });
  }

  function renderProfileCollection() {
    var grid = document.getElementById('urs-profile-collection-grid');
    var titleEl = document.getElementById('urs-profile-collection-title');
    if (!grid) return;

    if (!userProfile || !userProfile.likes || !userProfile.likes.length) {
      grid.innerHTML = '<p class="urs-text-muted">Like albums to build your collection.</p>';
      if (titleEl) titleEl.textContent = 'Liked Songs';
      return;
    }

    if (titleEl) titleEl.textContent = 'Liked Songs — ' + userProfile.likes.length + ' liked';
    var html = '';
    for (var i = 0; i < userProfile.likes.length; i++) {
      var like = userProfile.likes[i];
      var album = null;
      for (var j = 0; j < allAlbums.length; j++) {
        if (slugify(allAlbums[j].artist) === slugify(like.artist) && slugify(allAlbums[j].album) === slugify(like.album)) {
          album = allAlbums[j]; break;
        }
      }
      if (album) html += r2CardHtml(album);
    }
    grid.innerHTML = html || '<p class="urs-text-muted">Like albums to build your collection.</p>';
  }

  /* ── Section navigation ── */
  var sections = {
    home: document.getElementById('urs-section-home'),
    catalog: document.getElementById('urs-section-catalog'),
    downloads: document.getElementById('urs-section-downloads'),
    profile: document.getElementById('urs-section-profile')
  };

  function setActiveNav(id) {
    var links = document.querySelectorAll('.urs-sidebar__nav-link, .urs-tabbar__link');
    for (var i = 0; i < links.length; i++) {
      links[i].classList.toggle('is-active', links[i].dataset.section === id);
      if (links[i].dataset.section === id) links[i].setAttribute('aria-current', 'page');
      else links[i].removeAttribute('aria-current');
    }
    var keys = Object.keys(sections);
    for (var j = 0; j < keys.length; j++) {
      if (sections[keys[j]]) sections[keys[j]].style.display = (keys[j] === id) ? '' : 'none';
    }
    if (id === 'catalog' && searchInput) searchInput.focus();
  }

  var navLinks = document.querySelectorAll('[data-section]');
  for (var n = 0; n < navLinks.length; n++) {
    navLinks[n].addEventListener('click', function(e) {
      e.preventDefault();
      var sec = this.dataset.section;
      setActiveNav(sec);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ── Event delegation ── */
  document.addEventListener('click', function(e) {
    // Track click in drawer
    var trackItem = e.target.closest('.urs-drawer__track');
    if (trackItem && tracklistEl && tracklistEl.contains(trackItem)) {
      if (trackItem.classList.contains('urs-track--locked')) return;
      var idx = parseInt(trackItem.dataset.index, 10);
      if (!isNaN(idx)) playTrack(idx);
      return;
    }

    // Like button
    var likeBtn = e.target.closest('.urs-like__btn');
    if (likeBtn) {
      e.stopPropagation();
      e.preventDefault();
      toggleLike(likeBtn.dataset.artist, likeBtn.dataset.album, likeBtn);
      return;
    }

    // Card click (open drawer)
    var card = e.target.closest('.urs-card');
    if (card) { e.preventDefault(); if (card.dataset.locked === '1') { openUpgrade(card.dataset.needTier); } else { openDrawer(card); } return; }

    // Drawer close
    if (e.target.closest('#urs-drawer-close') || e.target === backdrop) closeDrawer();

    // See all links
    var seeAll = e.target.closest('[data-see-all]');
    if (seeAll && seeAll.dataset.seeAll !== undefined) {
      e.preventDefault();
      setActiveNav('catalog');
      return;
    }
    var seeAllArtist = e.target.closest('[data-see-all-artist]');
    if (seeAllArtist) {
      e.preventDefault();
      setActiveNav('catalog');
      if (artistFilter) {
        artistFilter.value = seeAllArtist.dataset.seeAllArtist;
        filterCatalog();
      }
      return;
    }

    // Download toggle
    var dlToggle = e.target.closest('[data-dl-toggle]');
    if (dlToggle) {
      var dlIdx = dlToggle.dataset.dlToggle;
      var dlTracks = document.getElementById('urs-dl-tracks-' + dlIdx);
      if (dlTracks) {
        var open = dlTracks.style.display !== 'none';
        dlTracks.style.display = open ? 'none' : '';
        dlToggle.setAttribute('aria-expanded', !open);
        dlToggle.textContent = open ? 'Tracks ▾' : 'Tracks ▴';
      }
      return;
    }

    // Download all
    var dlAll = e.target.closest('[data-dl-all]');
    if (dlAll) {
      var aIdx = parseInt(dlAll.dataset.dlAll, 10);
      if (!isNaN(aIdx) && allAlbums[aIdx]) {
        downloadAllSequential(allAlbums[aIdx].tracks || [], 0);
      }
      return;
    }

    // Single track download
    var dlTrack = e.target.closest('[data-dl-track]');
    if (dlTrack) {
      var ai = parseInt(dlTrack.dataset.dlAlbum, 10);
      var ti = parseInt(dlTrack.dataset.dlTrack, 10);
      if (!isNaN(ai) && !isNaN(ti) && allAlbums[ai] && allAlbums[ai].tracks[ti]) {
        var track = allAlbums[ai].tracks[ti];
        downloadFile(track.url, (ti + 1) + ' - ' + track.name + '.mp3');
      }
      return;
    }
  });

  /* ── Keyboard ── */
  document.addEventListener('keydown', function(e) {
    if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA' || e.target.tagName === 'SELECT') return;
    if (e.key === 'Enter') {
      var card = e.target.closest('.urs-card');
      if (card) { e.preventDefault(); if (card.dataset.locked === '1') { openUpgrade(card.dataset.needTier); } else { openDrawer(card); } }
      var track = e.target.closest('.urs-drawer__track');
      if (track && !track.classList.contains('urs-track--locked')) {
        var idx = parseInt(track.dataset.index, 10);
        if (!isNaN(idx)) playTrack(idx);
      }
    }
    if (e.key === 'Escape') closeDrawer();
    if (e.key === ' ' && !e.target.closest('input,textarea,button,a,select')) {
      e.preventDefault();
      togglePlay();
    }
    if (e.key === 'ArrowLeft' && e.ctrlKey && currentTracks.length) { e.preventDefault(); playTrack(currentTrackIndex - 1); }
    if (e.key === 'ArrowRight' && e.ctrlKey && currentTracks.length) { e.preventDefault(); playTrack(currentTrackIndex + 1); }
  });

  /* ── Search & Filter listeners ── */
  if (searchInput) {
    var debounceTimer;
    searchInput.addEventListener('input', function() {
      clearTimeout(debounceTimer);
      var q = searchInput.value.trim();
      if (q && catalogView === 'browse') { openCatalogResults('Results', allAlbums, 'search'); }
      else if (!q && catalogView === 'results' && resultsSource === 'search') { showBrowse(); return; }
      debounceTimer = setTimeout(filterCatalog, 200);
    });
  }
  if (searchClear) {
    searchClear.addEventListener('click', function() {
      if (searchInput) searchInput.value = '';
      if (catalogView === 'results' && resultsSource === 'search') { showBrowse(); } else { filterCatalog(); }
      if (searchInput) searchInput.focus();
    });
  }
  if (artistFilter) artistFilter.addEventListener('change', filterCatalog);
  if (sortFilter) sortFilter.addEventListener('change', filterCatalog);
  document.addEventListener('click', function (e) {
    var tile = e.target.closest && e.target.closest('.urs-gtile');
    if (tile) { e.preventDefault(); openGenreTile(tile.getAttribute('data-gtile')); return; }
    var back = e.target.closest && e.target.closest('#urs-genre-back');
    if (back) { e.preventDefault(); showBrowse(); }
  });

  /* ── R2 Albums (source of truth) ── */
  function loadR2Albums() {
    ursAuthedFetch(WORKER + '/api/albums')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        allAlbums = data.albums || [];
        try { _catSig = ursCatalogSig(allAlbums); } catch (e) {}
        renderHome(allAlbums);
        renderCatalog(allAlbums);
    renderTierBanner();
        renderSectionTiles();
        showBrowse();
        renderDownloads(allAlbums);
        loadLikesCounts(allAlbums);
      })
      .catch(function(e) { console.error('[URS] R2 albums error:', e); });
  }

  /* ── Catalogo ao vivo: o Leo publica e o membro ve sem dar F5 ──
     loadR2Albums() so roda uma vez no init E chama showBrowse(), entao nao da pra
     reusar aqui: recarregar no meio da navegacao jogaria o membro pra outra tela.
     Esta versao atualiza os dados e re-renderiza as listas SEM mexer em onde ele
     esta, e sem tocar no <audio> (que vive no drawer, fora destes renders). */
  var _catSig = '';
  var _catLast = 0;
  function ursCatalogSig(list) {
    var out = [];
    for (var i = 0; i < list.length; i++) {
      var a = list[i] || {};
      out.push((a.artistSlug || '') + '/' + (a.albumSlug || '') + ':' + (a.updatedAt || '') + ':' + (a.count || 0));
    }
    return out.join('|');
  }
  function ursRefreshCatalog() {
    var agora = Date.now();
    if (agora - _catLast < 20000) return;   // no maximo 1 checagem a cada 20s
    if (document.hidden) return;             // aba em segundo plano nao gasta rede
    _catLast = agora;
    ursAuthedFetch(WORKER + '/api/albums')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var novos = data.albums || [];
        if (!novos.length) return;
        var sig = ursCatalogSig(novos);
        if (!_catSig) { _catSig = sig; return; }  // primeira medicao: so guarda
        if (sig === _catSig) return;              // nada mudou
        _catSig = sig;
        allAlbums = novos;
        try {
          renderHome(allAlbums);
          renderCatalog(allAlbums);
          renderSectionTiles();
          renderDownloads(allAlbums);
          loadLikesCounts(allAlbums);
        } catch (e) { return; }
        try { ursToast('Novo conteudo disponivel'); } catch (e) {}
      })
      .catch(function () {});
  }
  // volta pra aba -> checa na hora (e o caso real: o Leo publica, o membro volta)
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) ursRefreshCatalog();
  });
  window.addEventListener('focus', function () { ursRefreshCatalog(); });
  setInterval(ursRefreshCatalog, 120000);

  /* ── Drawer split layout (F1S2-S2.9): lyrics sempre carregam, sem tabs ── */
  lyricsEnabled = true;

  /* ── Playlists (Onda 1) ── */
  sections.playlists = document.getElementById('urs-section-playlists');
  sections.perks = document.getElementById('urs-section-perks');
  sections.community = document.getElementById('urs-section-community');
  var plGrid = document.getElementById('urs-pl-grid');
  var plModal = document.getElementById('urs-pl-modal');
  var plNameInput = document.getElementById('urs-pl-name');
  var plErr = document.getElementById('urs-pl-err');
  var plLoaded = false;
  function plBase() { return WORKER + '/api/user/' + member.id + '/playlists'; }
  function plCover(p) {
    if (p.coverArtistSlug && p.coverAlbumSlug) return WORKER + '/cdn/' + p.coverArtistSlug + '/' + p.coverAlbumSlug + '/cover.png';
    return null;
  }
  // Playlist cover = worker-resolved covers[] (mosaic up to 4) → single → placeholder.
  function plCoverHtml(p) {
    var cs = (p && p.covers && p.covers.length) ? p.covers.slice() : (p && p.cover ? [p.cover] : []);
    if (!cs.length && p && p.coverArtistSlug && p.coverAlbumSlug) cs = [WORKER + '/cdn/' + p.coverArtistSlug + '/' + p.coverAlbumSlug + '/cover.png'];
    if (cs.length >= 4) return '<div class="urs-pl-card__cover urs-pl-card__cover--mosaic">' + cs.slice(0, 4).map(function (u) { return '<img src="' + escHtml(u) + '" alt="" loading="lazy">'; }).join('') + '</div>';
    if (cs.length >= 1) return '<div class="urs-pl-card__cover"><img src="' + escHtml(cs[0]) + '" alt="" loading="lazy"></div>';
    return '<div class="urs-pl-card__cover urs-pl-card__cover--empty">' + PL_ICON + '</div>';
  }
  var PL_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M21 15V6M18.5 18a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zM12 12H3M16 6H3M12 18H3"/></svg>';
  function renderPlaylists(list) {
    if (!plGrid) return;
    if (!list.length) {
      plGrid.innerHTML = '<div class="urs-pl-empty">' + PL_ICON + '<p>No playlists yet.</p><button type="button" class="urs-pl-newbtn" data-pl-open>Create your first</button></div>';
      return;
    }
    var h = '';
    for (var i = 0; i < list.length; i++) {
      var p = list[i];
      var cover = plCoverHtml(p);
      var sub = (p.trackCount || 0) + ' track' + (p.trackCount === 1 ? '' : 's') + (p.visibility === 'private' ? ' · Private' : '');
      h += '<div class="urs-pl-card" data-pl-id="' + escHtml(p.id) + '" role="button" tabindex="0">' + cover +
        '<div class="urs-pl-card__meta"><span class="urs-pl-card__name">' + escHtml(p.name || 'Untitled') + '</span>' +
        '<span class="urs-pl-card__count">' + sub + '</span></div></div>';
    }
    plGrid.innerHTML = h;
  }
  function loadPlaylists() {
    if (!member.id || !plGrid) return;
    plGrid.innerHTML = '<p class="urs-text-muted">Loading playlists…</p>';
    ursGetToken().then(function () {
      return fetch(plBase(), { headers: ursAuthHeaders() });
    }).then(function (r) { return r.json(); }).then(function (d) {
      renderPlaylists((d && d.playlists) || []);
    }).catch(function () {
      plGrid.innerHTML = '<p class="urs-text-muted">Could not load playlists.</p>';
    });
  }
  function openPlModal() { if (plModal) { plModal.hidden = false; if (plErr) plErr.textContent = ''; if (plNameInput) { plNameInput.value = ''; plNameInput.focus(); } } }
  function closePlModal() { if (plModal) plModal.hidden = true; }
  function createPlaylist() {
    var name = (plNameInput && plNameInput.value || '').trim();
    if (!name) { if (plNameInput) plNameInput.focus(); return; }
    ursGetToken().then(function () {
      return fetch(plBase(), { method: 'POST', headers: ursAuthHeaders({ 'Content-Type': 'application/json' }), body: JSON.stringify({ name: name }) });
    }).then(function (r) {
      if (r.ok) { closePlModal(); loadPlaylists(); return null; }
      return r.json().catch(function () { return {}; }).then(function (d) { if (plErr) plErr.textContent = d.error || 'Could not create playlist'; });
    }).catch(function () { if (plErr) plErr.textContent = 'Could not create playlist'; });
  }
  var plNewBtn = document.getElementById('urs-pl-new');
  if (plNewBtn) plNewBtn.addEventListener('click', openPlModal);
  var plCreateBtn = document.getElementById('urs-pl-create');
  if (plCreateBtn) plCreateBtn.addEventListener('click', createPlaylist);
  if (plNameInput) plNameInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') createPlaylist(); });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-pl-open]')) { e.preventDefault(); openPlModal(); }
    if (e.target.closest('[data-pl-close]')) { e.preventDefault(); closePlModal(); }
  });
  var plNav = document.querySelectorAll('[data-section="playlists"]');
  for (var pli = 0; pli < plNav.length; pli++) {
    plNav[pli].addEventListener('click', function () { if (!plLoaded) { plLoaded = true; loadPlaylists(); } });
  }

  /* -- Community wall (Onda 2 MVP: async posts) -- */
  var wallFeed = document.getElementById('urs-wall-feed');
  var wallInput = document.getElementById('urs-wall-input');
  var wallPostBtn = document.getElementById('urs-wall-post');
  var wallCount = document.getElementById('urs-wall-count');
  var wallPinnedEl = document.getElementById('urs-wall-pinned');
  var wallMoreWrap = document.getElementById('urs-wall-more');
  var wallMoreBtn = document.getElementById('urs-wall-more-btn');
  var wallMyAvatar = document.getElementById('urs-wall-myavatar');
  var wallLoaded = false;
  var wallPollTimer = null;
  var wallNextBefore = null;
  if (wallMyAvatar) { var _mn = (window.URS_CUSTOMER_NAME || (member && member.name) || 'M').trim(); wallMyAvatar.textContent = _mn.slice(0, 1).toUpperCase(); }
  function wallTime(ts) { var d = Date.now() - ts; if (d < 60000) return 'now'; if (d < 3600000) return Math.floor(d / 60000) + 'm'; if (d < 86400000) return Math.floor(d / 3600000) + 'h'; return Math.floor(d / 86400000) + 'd'; }
  var WALL_IC_HEART = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><path d="M12 20.5l-1.4-1.27C5.4 14.36 2 11.28 2 7.5 2 4.42 4.42 2 7.5 2c1.74 0 3.41.81 4.5 2.09C13.09 2.81 14.76 2 16.5 2 19.58 2 22 4.42 22 7.5c0 3.78-3.4 6.86-8.6 11.73L12 20.5z"/></svg>';
  var WALL_IC_COMMENT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>';
  var WALL_IC_PIN = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M14 4l6 6-3 1-3 3-1 5-2-2-4 4-1-1 4-4-2-2 5-1 3-3 1-3z"/></svg>';
  var WALL_IC_STAR = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.9 6.1 6.6.9-4.8 4.6 1.2 6.6L12 17.8 6.1 20.8l1.2-6.6L2.5 9l6.6-.9L12 2z"/></svg>';
  function wallBadge(p) {
    if (p && p.authorRole === 'artist') return '<span class="urs-wall__badge urs-wall__badge--artist">' + WALL_IC_STAR + 'Artist</span>';
    var t = p && p.tier;
    if (t === 'legend') return '<span class="urs-wall__badge urs-wall__badge--insider">Insider</span>';
    if (t === 'insider') return '<span class="urs-wall__badge urs-wall__badge--insider">Insider</span>';
    return '';
  }
  function wallCardHtml(p, opts) {
    opts = opts || {};
    var initials = (p.handle || 'M').trim().slice(0, 1).toUpperCase();
    var tagsHtml = (p.tags || []).map(function (t) { return '<span class="urs-wall__tag">#' + escHtml(t) + '</span>'; }).join('');
    var likes = (typeof p.likeCount === 'number') ? p.likeCount : (p.likes || 0);
    var liked = !!(p.likedByMe || p.liked);
    var comments = (typeof p.commentCount === 'number') ? p.commentCount : 0;
    var pinLabel = opts.pinned ? '<div class="urs-wall__pinlabel">' + WALL_IC_PIN + 'Pinned by the band</div>' : '';
    return '<div class="urs-wall__post' + (opts.pinned ? ' urs-wall__post--artist' : '') + '" data-post-id="' + escHtml(p.id || '') + '">' +
      '<div class="urs-wall__avatar">' + escHtml(initials) + '</div>' +
      '<div class="urs-wall__pbody">' + pinLabel +
      '<div class="urs-wall__head"><span class="urs-wall__author">' + escHtml(p.handle || 'Member') + '</span>' + wallBadge(p) +
      '<span class="urs-wall__time">' + wallTime(p.createdAt) + '</span></div>' +
      '<p class="urs-wall__text">' + escHtml(p.body) + '</p>' +
      (p.image ? '<img class="urs-wall__image" src="' + escHtml(p.image) + '" alt="" loading="lazy">' : '') +
      (tagsHtml ? '<div class="urs-wall__tags">' + tagsHtml + '</div>' : '') +
      '<div class="urs-wall__actions">' +
        '<button type="button" class="urs-wall__act urs-wall__act--like' + (liked ? ' is-liked' : '') + '" data-like-id="' + escHtml(p.id || '') + '" aria-pressed="' + (liked ? 'true' : 'false') + '">' + WALL_IC_HEART + '<span class="urs-wall__actcount">' + likes + '</span></button>' +
        '<button type="button" class="urs-wall__act urs-wall__act--comment" data-comment-id="' + escHtml(p.id || '') + '" aria-expanded="false">' + WALL_IC_COMMENT + '<span class="urs-wall__actcount">' + comments + '</span></button>' +
      '</div>' +
      '<div class="urs-wall__thread" data-thread-for="' + escHtml(p.id || '') + '" hidden></div>' +
      '</div></div>';
  }
  function wallEmptyHtml() {
    return '<div class="urs-wall__empty"><div class="urs-wall__empty-ic">' + WALL_IC_COMMENT + '</div>' +
      '<p class="urs-wall__empty-title">No posts yet</p>' +
      '<p class="urs-wall__empty-sub">Be the first to break the silence — share something with the band and members.</p></div>';
  }
  function renderPosts(posts, append) {
    if (!wallFeed) return;
    posts = posts || [];
    if (!append && !posts.length && !(wallPinnedEl && !wallPinnedEl.hidden)) { wallFeed.innerHTML = wallEmptyHtml(); return; }
    var h = '';
    for (var i = 0; i < posts.length; i++) h += wallCardHtml(posts[i]);
    if (append) { var dead = wallFeed.querySelector('.urs-wall__empty'); if (dead) dead.remove(); wallFeed.insertAdjacentHTML('beforeend', h); }
    else wallFeed.innerHTML = h || (wallPinnedEl && !wallPinnedEl.hidden ? '' : wallEmptyHtml());
  }
  function renderPinned(p) {
    if (!wallPinnedEl) return;
    if (!p) { wallPinnedEl.hidden = true; wallPinnedEl.innerHTML = ''; return; }
    wallPinnedEl.innerHTML = wallCardHtml(p, { pinned: true });
    wallPinnedEl.hidden = false;
  }
  function loadPosts() {
    if (!wallFeed) return;
    ursAuthedFetch(WORKER + '/api/posts?limit=20').then(function (r) { return r.json(); }).then(function (d) {
      renderPinned((d && d.pinned) || null);
      renderPosts((d && d.posts) || [], false);
      wallNextBefore = (d && d.nextBefore) || null;
      if (wallMoreWrap) wallMoreWrap.hidden = !wallNextBefore;
    }).catch(function () { wallFeed.innerHTML = '<p class="urs-text-muted">Could not load posts.</p>'; });
  }
  function loadMorePosts() {
    if (!wallNextBefore || !wallMoreBtn) return;
    wallMoreBtn.disabled = true;
    ursAuthedFetch(WORKER + '/api/posts?limit=20&before=' + encodeURIComponent(wallNextBefore)).then(function (r) { return r.json(); }).then(function (d) {
      renderPosts((d && d.posts) || [], true);
      wallNextBefore = (d && d.nextBefore) || null;
      if (wallMoreWrap) wallMoreWrap.hidden = !wallNextBefore;
      wallMoreBtn.disabled = false;
    }).catch(function () { wallMoreBtn.disabled = false; });
  }
  function toggleWallLike(id, btn) {
    if (!id || !btn) return;
    var countEl = btn.querySelector('.urs-wall__actcount');
    var wasLiked = btn.classList.contains('is-liked');
    var cur = parseInt((countEl && countEl.textContent) || '0', 10) || 0;
    btn.classList.toggle('is-liked');
    btn.setAttribute('aria-pressed', wasLiked ? 'false' : 'true');
    if (countEl) countEl.textContent = Math.max(0, cur + (wasLiked ? -1 : 1));
    ursAuthedFetch(WORKER + '/api/posts/' + encodeURIComponent(id) + '/like', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
      if (!d) return;
      btn.classList.toggle('is-liked', !!d.liked);
      btn.setAttribute('aria-pressed', d.liked ? 'true' : 'false');
      if (countEl && typeof d.likeCount === 'number') countEl.textContent = d.likeCount;
    }).catch(function () {
      btn.classList.toggle('is-liked', wasLiked);
      btn.setAttribute('aria-pressed', wasLiked ? 'true' : 'false');
      if (countEl) countEl.textContent = cur;
    });
  }
  /* ── Comments (phase-2): inline thread per post ── */
  function cidEsc(id) { return (window.CSS && CSS.escape) ? CSS.escape(id) : String(id).replace(/"/g, '\\"'); }
  function wallCommentHtml(c) {
    var ini = (c.handle || 'M').trim().slice(0, 1).toUpperCase();
    var badge = '';
    if (c.authorRole === 'artist') badge = '<span class="urs-wall__badge urs-wall__badge--artist">' + WALL_IC_STAR + 'Artist</span>';
    else if (c.tier === 'legend') badge = '<span class="urs-wall__badge urs-wall__badge--insider">Insider</span>';
    else if (c.tier === 'insider') badge = '<span class="urs-wall__badge urs-wall__badge--insider">Insider</span>';
    return '<div class="urs-wall__comment' + (c.authorRole === 'artist' ? ' urs-wall__comment--artist' : '') + '">' +
      '<div class="urs-wall__cavatar">' + escHtml(ini) + '</div>' +
      '<div class="urs-wall__cbody"><div class="urs-wall__chead"><span class="urs-wall__author">' + escHtml(c.handle || 'Member') + '</span>' + badge +
      '<span class="urs-wall__time">' + wallTime(c.createdAt) + '</span></div>' +
      '<p class="urs-wall__ctext">' + escHtml(c.body) + '</p></div></div>';
  }
  function renderThread(threadEl, pid, comments) {
    var list = (comments && comments.length) ? comments.map(wallCommentHtml).join('') : '<p class="urs-wall__cempty">No comments yet. Start the conversation.</p>';
    threadEl.innerHTML = '<div class="urs-wall__clist">' + list + '</div>' +
      '<div class="urs-wall__cform"><textarea class="urs-wall__cinput" data-cinput="' + escHtml(pid) + '" placeholder="Write a comment…" maxlength="300" rows="1"></textarea>' +
      '<button type="button" class="urs-wall__csend" data-csend="' + escHtml(pid) + '">Send</button></div>';
  }
  function syncCommentCount(pid, n) {
    if (typeof n !== 'number') return;
    [].forEach.call(document.querySelectorAll('[data-comment-id="' + cidEsc(pid) + '"] .urs-wall__actcount'), function (el) { el.textContent = n; });
  }
  function loadThread(pid, threadEl) {
    threadEl.innerHTML = '<p class="urs-wall__cloading">Loading comments…</p>';
    ursAuthedFetch(WORKER + '/api/posts/' + encodeURIComponent(pid) + '/comments')
      .then(function (r) { return r.json(); }).then(function (d) {
        renderThread(threadEl, pid, (d && d.comments) || []);
        syncCommentCount(pid, d && d.commentCount);
      }).catch(function () { threadEl.innerHTML = '<p class="urs-wall__cempty">Could not load comments.</p>'; });
  }
  function toggleThread(pid, btn) {
    if (!pid) return;
    var post = btn.closest('.urs-wall__post');
    var threadEl = post && post.querySelector('.urs-wall__thread[data-thread-for]');
    if (!threadEl) return;
    if (threadEl.hasAttribute('hidden')) { threadEl.removeAttribute('hidden'); btn.setAttribute('aria-expanded', 'true'); loadThread(pid, threadEl); }
    else { threadEl.setAttribute('hidden', ''); btn.setAttribute('aria-expanded', 'false'); }
  }
  function sendComment(pid, inputEl, btn) {
    var text = (inputEl && inputEl.value || '').trim();
    if (!text || !btn) return;
    btn.disabled = true;
    ursGetToken().then(function () {
      return fetch(WORKER + '/api/posts/' + encodeURIComponent(pid) + '/comments', { method: 'POST', headers: ursAuthHeaders({ 'Content-Type': 'application/json' }), body: JSON.stringify({ body: text, handle: (window.URS_CUSTOMER_NAME || member.name || 'Member') }) });
    }).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
      btn.disabled = false;
      if (!d) return;
      if (inputEl) inputEl.value = '';
      var post = btn.closest('.urs-wall__post');
      var threadEl = post && post.querySelector('.urs-wall__thread[data-thread-for]');
      if (threadEl) loadThread(pid, threadEl);
      else syncCommentCount(pid, d.commentCount);
    }).catch(function () { btn.disabled = false; });
  }
  document.addEventListener('click', function (e) {
    var cbtn = e.target.closest && e.target.closest('.urs-wall__act--comment');
    if (cbtn && cbtn.hasAttribute('data-comment-id')) { e.preventDefault(); toggleThread(cbtn.getAttribute('data-comment-id'), cbtn); return; }
    var send = e.target.closest && e.target.closest('[data-csend]');
    if (send) { e.preventDefault(); var sp = send.parentNode.querySelector('[data-cinput]'); sendComment(send.getAttribute('data-csend'), sp, send); return; }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey && e.target && e.target.matches && e.target.matches('[data-cinput]')) {
      e.preventDefault();
      var send = e.target.parentNode.querySelector('[data-csend]');
      sendComment(e.target.getAttribute('data-cinput'), e.target, send);
    }
  });
  function postToWall() {
    var text = (wallInput && wallInput.value || '').trim();
    if (!text) return;
    if (wallPostBtn) wallPostBtn.disabled = true;
    ursGetToken().then(function () {
      return fetch(WORKER + '/api/posts', { method: 'POST', headers: ursAuthHeaders({ 'Content-Type': 'application/json' }), body: JSON.stringify({ body: text, handle: (window.URS_CUSTOMER_NAME || member.name || 'Member') }) });
    }).then(function (r) { if (wallPostBtn) wallPostBtn.disabled = false; if (r.ok) { if (wallInput) wallInput.value = ''; if (wallCount) wallCount.textContent = '0/500'; loadPosts(); } }).catch(function () { if (wallPostBtn) wallPostBtn.disabled = false; });
  }
  if (wallPostBtn) wallPostBtn.addEventListener('click', postToWall);
  if (wallInput) wallInput.addEventListener('input', function () {
    var n = wallInput.value.length;
    if (wallCount) { wallCount.textContent = n + '/500'; wallCount.classList.toggle('is-near', n >= 450); }
    wallInput.style.height = 'auto';
    wallInput.style.height = Math.min(wallInput.scrollHeight, 240) + 'px';
  });
  if (wallMoreBtn) wallMoreBtn.addEventListener('click', loadMorePosts);
  if (wallFeed) wallFeed.addEventListener('click', function (e) { var b = e.target.closest && e.target.closest('.urs-wall__act--like'); if (b) toggleWallLike(b.getAttribute('data-like-id'), b); });
  if (wallPinnedEl) wallPinnedEl.addEventListener('click', function (e) { var b = e.target.closest && e.target.closest('.urs-wall__act--like'); if (b) toggleWallLike(b.getAttribute('data-like-id'), b); });
  var wallNav = document.querySelectorAll('[data-section="community"]');
  for (var wi = 0; wi < wallNav.length; wi++) {
    wallNav[wi].addEventListener('click', function () {
      if (!wallLoaded) { wallLoaded = true; loadPosts(); }
      if (!wallPollTimer) wallPollTimer = setInterval(function () { var sc = document.getElementById('urs-section-community'); if (sc && getComputedStyle(sc).display !== 'none') loadPosts(); }, 20000);
    });
  }

  /* -- MEMBER-O8: From-the-artist feed in Perks tab (Leo's announcements) -- */
  // Reuses #7's richer wallCardHtml (artist badge, tags, like btn) for card parity.
  function ursRenderPostCards(posts, container, emptyHtml) {
    if (!container) return;
    if (!posts || !posts.length) { container.innerHTML = emptyHtml || '<p class="urs-text-muted">Nothing here yet.</p>'; return; }
    var h = '';
    for (var i = 0; i < posts.length; i++) h += wallCardHtml(posts[i]);
    container.innerHTML = h;
  }
  var URS_LEO_ID = '9592927813699';
  var perksArtistFeed = document.getElementById('urs-perks-artist-feed');
  var perksArtistLoaded = false;
  function loadPerksArtistPosts() {
    if (!perksArtistFeed) return;
    ursAuthedFetch(WORKER + '/api/posts?limit=20')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var all = (d && d.posts) ? d.posts.slice() : [];
        if (d && d.pinned) all.unshift(d.pinned);
        var artistPosts = all.filter(function (p) { return p && (p.authorRole === 'artist' || String(p.cid) === URS_LEO_ID); });
        ursRenderPostCards(artistPosts, perksArtistFeed, '<p class="urs-text-muted" style="text-align:center;padding:40px">No announcements yet.</p>');
      })
      .catch(function () { perksArtistFeed.innerHTML = '<p class="urs-text-muted">Could not load announcements.</p>'; });
  }
  if (perksArtistFeed) perksArtistFeed.addEventListener('click', function (e) { var b = e.target.closest && e.target.closest('.urs-wall__act--like'); if (b) toggleWallLike(b.getAttribute('data-like-id'), b); });
  var perksNav = document.querySelectorAll('[data-section="perks"]');
  for (var pk = 0; pk < perksNav.length; pk++) {
    perksNav[pk].addEventListener('click', function () { if (!perksArtistLoaded) { perksArtistLoaded = true; loadPerksArtistPosts(); } });
  }

  /* -- Add to playlist (Onda 1 inc2) -- */
  var addSheet = null, addTrackIdx = -1;
  function parseTrackRef(streamUrl) {
    var m = String(streamUrl || '').match(/\/cdn\/([^/]+)\/([^/]+)\/([^/?#]+?)(?:\.mp3)?(?:[?#].*)?$/i);
    if (!m) return null;
    return { artistSlug: m[1], albumSlug: m[2], trackId: m[3].replace(/\.mp3$/i, '') };
  }
  function ursToast(msg) {
    var t = document.createElement('div'); t.className = 'urs-toast'; t.textContent = msg; document.body.appendChild(t);
    setTimeout(function () { t.classList.add('urs-toast--in'); }, 10);
    setTimeout(function () { t.classList.remove('urs-toast--in'); setTimeout(function () { t.remove(); }, 300); }, 2400);
  }
  function ensureAddSheet() {
    if (addSheet) return addSheet;
    addSheet = document.createElement('div'); addSheet.className = 'urs-addsheet'; addSheet.hidden = true;
    addSheet.innerHTML = '<div class="urs-addsheet__backdrop" data-add-close></div><div class="urs-addsheet__box" role="dialog" aria-modal="true" aria-label="Add to playlist"><div class="urs-addsheet__handle"></div><h3 class="urs-addsheet__title">Add to playlist</h3><div class="urs-addsheet__list" id="urs-addsheet-list"></div></div>';
    document.body.appendChild(addSheet);
    return addSheet;
  }
  function closeAddSheet() { if (addSheet) addSheet.hidden = true; }
  function openAddSheet(idx) {
    addTrackIdx = idx;
    var sh = ensureAddSheet(); sh.hidden = false;
    var list = document.getElementById('urs-addsheet-list');
    list.innerHTML = '<p class="urs-text-muted" style="padding:16px">Loading…</p>';
    ursGetToken().then(function () { return fetch(WORKER + '/api/user/' + member.id + '/playlists', { headers: ursAuthHeaders() }); })
      .then(function (r) { return r.json(); }).then(function (d) {
        var pls = (d && d.playlists) || [];
        var h = '<button type="button" class="urs-addsheet__row urs-addsheet__row--new" data-add-new><span class="urs-addsheet__plus">+</span> New playlist</button>';
        for (var i = 0; i < pls.length; i++) h += '<button type="button" class="urs-addsheet__row" data-add-to="' + escHtml(pls[i].id) + '"><span class="urs-addsheet__rowname">' + escHtml(pls[i].name || 'Untitled') + '</span><span class="urs-addsheet__rowcount">' + (pls[i].trackCount || 0) + '</span></button>';
        list.innerHTML = h;
      }).catch(function () { list.innerHTML = '<p class="urs-text-muted" style="padding:16px">Could not load.</p>'; });
  }
  function addTrackToPlaylist(pid) {
    var t = currentTracks[addTrackIdx];
    if (!t) { closeAddSheet(); return; }
    var ref = parseTrackRef(t.stream || t.url);
    if (!ref) { closeAddSheet(); ursToast('Could not add'); return; }
    ursGetToken().then(function () {
      return fetch(WORKER + '/api/user/' + member.id + '/playlists/' + pid + '/tracks', { method: 'POST', headers: ursAuthHeaders({ 'Content-Type': 'application/json' }), body: JSON.stringify(ref) });
    }).then(function (r) {
      closeAddSheet();
      if (r.ok) { ursToast('Added to playlist'); if (typeof plLoaded !== 'undefined') plLoaded = false; }
      else return r.json().catch(function () { return {}; }).then(function (d) { ursToast(d.error || 'Could not add'); });
    }).catch(function () { closeAddSheet(); ursToast('Could not add'); });
  }
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-add-track]');
    if (addBtn) { e.preventDefault(); e.stopPropagation(); openAddSheet(parseInt(addBtn.getAttribute('data-add-track'), 10)); return; }
    if (e.target.closest('[data-add-close]')) { closeAddSheet(); return; }
    var addTo = e.target.closest('[data-add-to]');
    if (addTo) { e.preventDefault(); addTrackToPlaylist(addTo.getAttribute('data-add-to')); return; }
    if (e.target.closest('[data-add-new]')) { e.preventDefault(); closeAddSheet(); if (typeof openPlModal === 'function') openPlModal(); return; }
  });

  /* ── Init ── */
  loadR2Albums();
  if (member.id) { ursGetToken().then(function() { loadUserProfile(); }); }
  renderProfile();
  // MEMBER-O8: warm-load artist feed once (handles #perks entry hash)
  if (perksArtistFeed) { perksArtistLoaded = true; loadPerksArtistPosts(); }
})();


/* MEMBER-O11 — belt-and-suspenders: kill social-proof sales popups (Nudgify/Qikify) on member pages.
   This file loads ONLY on member pages, so the storefront is never touched. */
(function ursHideSocialProof() {
  var SEL = '#qikify-salekit, .qikify-salekit-app, .qsk-popup, .qsk-sproof-elm, [id^="nudgify"], [class*="nudgify"]';
  function hide(root) {
    try {
      if (root.nodeType === 1 && root.matches && root.matches(SEL)) root.style.setProperty('display', 'none', 'important');
      if (root.querySelectorAll) [].forEach.call(root.querySelectorAll(SEL), function (n) { n.style.setProperty('display', 'none', 'important'); });
    } catch (e) {}
  }
  hide(document);
  try {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) if (added[j].nodeType === 1) hide(added[j]);
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();

/* Lyrics copy/selection guard (member-only) */
(function(){ if(window.__ursLyricsGuard) return; window.__ursLyricsGuard=1; function inL(t){ return t && t.closest && t.closest('.urs-fullscreen__lyrics, .urs-lyrics'); } ['copy','cut','contextmenu','selectstart','dragstart'].forEach(function(ev){ document.addEventListener(ev, function(e){ if(inL(e.target)) e.preventDefault(); }, true); }); })();

/* MEMBER: click-to-expand announcement/post images (lightbox) — 2026-07-12 (reversible: node _revert_member_lightbox.cjs --go) */
(function(){
  function openLB(src, alt){
    var old=document.getElementById('urs-lightbox'); if(old) old.remove();
    var lb=document.createElement('div'); lb.id='urs-lightbox'; lb.className='urs-lightbox';
    var btn=document.createElement('button'); btn.type='button'; btn.className='urs-lightbox__close'; btn.setAttribute('aria-label','Fechar'); btn.innerHTML='&times;';
    var im=document.createElement('img'); im.className='urs-lightbox__img'; im.src=src; im.alt=alt||'';
    lb.appendChild(btn); lb.appendChild(im); document.body.appendChild(lb);
    document.documentElement.style.overflow='hidden';
    requestAnimationFrame(function(){ lb.classList.add('is-open'); });
    function onKey(e){ if(e.key==='Escape') close(); }
    function close(){ lb.classList.remove('is-open'); document.documentElement.style.overflow=''; document.removeEventListener('keydown',onKey); setTimeout(function(){ if(lb.parentNode) lb.remove(); },200); }
    lb.addEventListener('click',function(e){ if(e.target===lb || (e.target.closest && e.target.closest('.urs-lightbox__close'))) close(); });
    document.addEventListener('keydown',onKey);
  }
  document.addEventListener('click',function(e){
    var t=e.target; if(!t||!t.closest) return;
    var img=t.closest('.urs-wall__image'); if(!img) return;
    e.preventDefault(); openLB(img.currentSrc||img.src, img.alt);
  });
})();

/* lb cache-bump 2026-07-13 */

/* Diagnostico de audio on-screen: /pages/member?audiodiag=1 */
(function(){
  try {
    if (location.search.indexOf('audiodiag') === -1) return;
    var W = 'https://unreal-upload.unreal-rock.workers.dev';
    var cid = String(window.URS_CUSTOMER_ID || '');
    var box = document.createElement('div');
    box.style.cssText = 'position:fixed;inset:10px;z-index:2147483647;background:#0d0d0d;color:#fff;font:13px/1.7 monospace;padding:16px;overflow:auto;border:2px solid #6c5ce7;border-radius:10px';
    function log(t){ var d=document.createElement('div'); d.textContent=t; box.appendChild(d); }
    function ready(){
      document.body.appendChild(box);
      log('DIAGNOSTICO DE AUDIO — tire um PRINT desta tela e mande');
      log('(so aparece com ?audiodiag=1)');
      log(' ');
      log('1) Logado (cid): ' + (cid || 'NAO LOGADO'));
      if (!cid) { log('>> Faca login e reabra o link.'); return; }
      (async function(){
        var tok=null, tier=null;
        try { var ra=await fetch(W+'/api/auth',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({customer_id:cid,tier:'listener'})}); var da=await ra.json(); tok=da.token; tier=da.tier; log('2) Token: '+(tok?'OK':'FALHOU')+' | tier '+tier+' | http '+ra.status); }
        catch(e){ log('2) Token: ERRO '+e.message); }
        var url=null, n=0;
        if (tok) { try { var rc=await fetch(W+'/api/albums',{headers:{Authorization:'Bearer '+tok}}); var dc=await rc.json(); var al=dc.albums||[]; for(var i=0;i<al.length;i++){var tr=al[i].tracks||[];for(var j=0;j<tr.length;j++){if(tr[j].url){n++;if(!url)url=tr[j].url;}}} log('3) Catalogo: '+n+' faixas com URL'); } catch(e){ log('3) Catalogo: ERRO '+e.message); } }
        if (!url) { log('>> sem URL de faixa; parei.'); return; }
        try { var rf=await fetch(url); log('4) fetch da musica: HTTP '+rf.status+(rf.ok?'  (FETCH PASSA)':'  (nao ok)')); }
        catch(e){ log('4) fetch da musica: BLOQUEADO/ERRO ('+e.message+')'); }
        var a=new Audio(); a.src=url; a.volume=1; var aerr=null;
        a.addEventListener('error', function(){ aerr = a.error?a.error.code:'?'; });
        try { await a.play(); } catch(e){ log('5) play() rejeitou: '+e.name); }
        await new Promise(function(r){ setTimeout(r,3500); });
        log('5) <audio> direto: andou='+(a.currentTime>0.2)+' tempo='+a.currentTime.toFixed(1)+'s mudo='+a.muted+' vol='+a.volume+' rs='+a.readyState+' erro='+aerr);
        try { a.pause(); } catch(e){}
        try { var rb=await fetch(url); var b=await rb.blob(); var a2=new Audio(); a2.src=URL.createObjectURL(b); a2.volume=1; try{ await a2.play(); }catch(e){} await new Promise(function(r){ setTimeout(r,2500); }); log('6) via BLOB: andou='+(a2.currentTime>0.2)+' tempo='+a2.currentTime.toFixed(1)+'s'); try{ a2.pause(); }catch(e){} }
        catch(e){ log('6) via blob: ERRO '+e.message); }
        log(' ');
        log('LEITURA:');
        log('- (5) ou (6) andou=true mas sem som = mudo/saida de audio');
        log('- (5) andou=false, (4) PASSA, (6) andou=true = bloqueio de midia (blob resolve)');
        log('- (4) BLOQUEADO = adblock/rede bloqueando tudo');
        log('>> PRINT ESSA TELA <<');
      })();
    }
    if (document.body) ready(); else document.addEventListener('DOMContentLoaded', ready);
  } catch(e){}
})();
